/**
 * File generated by js-routes 2.2.8
 * Based on Rails 7.0.7.2 routes of Inspectpoint::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * (/:locale)/subcontractor/invites/:token/accept_for_existing_company(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptForExistingCompanySubcontractorInvitePath = /*#__PURE__*/ __jsr.r({"locale":{},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"accept_for_existing_company"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/invites/:token/accept(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptSubcontractorInvitePath = /*#__PURE__*/ __jsr.r({"locale":{},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/invites/:token/acceptance(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptanceSubcontractorInvitePath = /*#__PURE__*/ __jsr.r({"locale":{},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"acceptance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:account_id/buildings/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:account_id/buildings(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"account_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:account_id/contacts/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:account_id/contacts(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountContactsPath = /*#__PURE__*/ __jsr.r({"locale":{},"account_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id/account_details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountDetailsAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"account_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/account_info/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"account_info"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/account_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountInfoIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"account_info"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:account_id/sales_people(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSalesPeoplePath = /*#__PURE__*/ __jsr.r({"locale":{},"account_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"sales_people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:account_id/sales_people/:id(.:format)
 * @param {any} accountId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSalesPersonPath = /*#__PURE__*/ __jsr.r({"locale":{},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"sales_people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api_keys/:id/activate_toggle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateToggleApiKeyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate_toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_questions/:id/activate_toggle(.:format)
 * @param {any} objectType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateToggleGenericQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate_toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inventory_sources/:id/activate_toggle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateToggleInventorySourcePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inventory_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate_toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractors/:id/activate_toggle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateToggleSubcontractorPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate_toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/active(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/code_years/:id/active_toggle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeToggleCodeYearPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"code_years"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_types/:id/active_toggle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeToggleEquipmentTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"active_toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_settings/add_additional_timezones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addAdditionalTimezonesCompanySettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_settings"],[2,[7,"/"],[2,[6,"add_additional_timezones"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/:id/add_building(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addBuildingContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/add_contact/:contact_id(.:format)
 * @param {any} id
 * @param {any} contactId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addContactBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"contact_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_contact"],[2,[7,"/"],[2,[3,"contact_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:id/add_contacts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addContactsWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:id/add_materials_used(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addMaterialsUsedWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_materials_used"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/:id/add_note(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addNoteProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/add_sales_person(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addSalesPersonBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_sales_person"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_answer_deficiencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmDeviceAnswerDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_answer_deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_answer_deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmDeviceAnswerDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_answer_deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_catalogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmDeviceCatalogPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_catalogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmDeviceCatalogsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmDeviceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmDeviceTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/control_panels/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/control_panels(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemControlPanelsPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"control_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_system_deficiencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_system_deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_system_deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_system_deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/device_legends/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemDeviceLegendPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"device_legends"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/device_legends(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemDeviceLegendsPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"device_legends"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/import(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_ancillary_devices/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcAncillaryDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_ancillary_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_ancillary_devices(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcAncillaryDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_ancillary_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_annunciators/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_annunciators(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcAnnunciatorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_control_panels/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_control_panels(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcControlPanelsPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_data_communication_links/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_data_communication_links(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcDataCommunicationLinksPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_power_supplies(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcPowerSuppliesPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_power_supplies/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_printers/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcPrinterPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_printers(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcPrintersPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_printers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_remote_trouble_signal_units/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_remote_trouble_signal_units(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcRemoteTroubleSignalUnitsPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_voice_communications/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_voice_communications(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alarmSystemUlcVoiceCommunicationsPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/all_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"all_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alternate_headers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alternateHeaderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alternate_headers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alternate_headers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alternateHeadersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alternate_headers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answer_choices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answerChoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answer_choices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answer_choices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answerChoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answer_choices"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answers/:answer_id/deficiency_photos/:id(.:format)
 * @param {any} answerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"answer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answers/:answer_id/deficiency_photos(.:format)
 * @param {any} answerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const answersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/internal/activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalActivitiesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/buildings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalBuildingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalDeficiencyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/deficiency_resolution_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalDeficiencyResolutionStatusesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"deficiency_resolution_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/holidays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalHolidayPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/holidays(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalHolidaysPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"holidays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/inspections/:inspection_id/documents/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalInspectionDocumentPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/inspections/:inspection_id/documents/:document_id/deficiencies(.:format)
 * @param {any} inspectionId
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalInspectionDocumentDeficienciesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"document_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/inspections/:inspection_id/document_types(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalInspectionDocumentTypesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/inspections/:inspection_id/documents(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalInspectionDocumentsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/inspection_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalInspectionStatusesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"inspection_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/price_rule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalPriceRulePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"price_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/service_visit_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalServiceVisitStatusesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"service_visit_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/signatures/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalSignaturePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/signature_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalSignatureTypesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"signature_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/signatures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalSignaturesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/subcontractors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalSubcontractorsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"subcontractors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/technicians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalTechniciansPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"technicians"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/tenant_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalTenantInfoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"tenant_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/time_offs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalTimeOffPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"time_offs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/time_offs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalTimeOffsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"time_offs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/time_zones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalTimeZonesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"time_zones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalVisitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/visit_priorities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalVisitPrioritiesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"visit_priorities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalVisitsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/work_orders/:work_order_id/documents/:id(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalWorkOrderDocumentPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/work_orders/:work_order_id/document_types(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalWorkOrderDocumentTypesPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/internal/work_orders/:work_order_id/documents(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiInternalWorkOrderDocumentsPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api_keys/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiKeyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api_keys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiKeysPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api_keys"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/mobile/v1/alarm_systems/:alarm_system_id/alarm_devices/:id
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiMobileV1AlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/mobile/v1/alarm_systems/:alarm_system_id/alarm_devices/:alarm_device_id/alarm_device_answers/:id
 * @param {any} alarmSystemId
 * @param {any} alarmDeviceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiMobileV1AlarmSystemAlarmDeviceAlarmDeviceAnswerPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"alarm_device_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"alarm_device_id"],[2,[7,"/"],[2,[6,"alarm_device_answers"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/mobile/v1/alarm_systems/:alarm_system_id/alarm_devices/:alarm_device_id/alarm_device_answers
 * @param {any} alarmSystemId
 * @param {any} alarmDeviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiMobileV1AlarmSystemAlarmDeviceAlarmDeviceAnswersPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"alarm_device_id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"alarm_device_id"],[2,[7,"/"],[6,"alarm_device_answers"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/mobile/v1/alarm_systems/:alarm_system_id/alarm_devices/:alarm_device_id/record
 * @param {any} alarmSystemId
 * @param {any} alarmDeviceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiMobileV1AlarmSystemAlarmDeviceRecordPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"alarm_device_id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"alarm_device_id"],[2,[7,"/"],[6,"record"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/mobile/v1/alarm_systems/:alarm_system_id/alarm_devices
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiMobileV1AlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[6,"alarm_devices"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalBuildingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:building_id/back_flows(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalBuildingBackFlowsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"back_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:building_id/deficiencies(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalBuildingDeficienciesPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:building_id/inspections(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalBuildingInspectionsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/building_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalBuildingNotePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"building_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:building_id/reports(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalBuildingReportsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:building_id/visits(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalBuildingVisitsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalBuildingsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/contacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalContactPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalContactsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/deficiencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalDeficienciesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalDeficiencyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/deficiency_resolution_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalDeficiencyResolutionStatusesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"deficiency_resolution_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalDocumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalDocumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalDocumentTypesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalDocumentsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/attachments/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionAttachmentPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/attachments(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionAttachmentsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/building_notes(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionBuildingNotesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"building_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/contacts(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionContactsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/deficiencies(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionDeficienciesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/documents/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionDocumentPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/document_types(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionDocumentTypesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/documents(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionDocumentsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/invoices(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionInvoicesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/related_items(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionRelatedItemsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"related_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/reports/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionReportPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/reports(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionReportsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:inspection_id/signatures(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionSignaturesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInvoicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalInvoicesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalLookupPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalMaterialsAndServicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalMaterialsAndServicesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalMaterialsAndServicesTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalMaterialsAndServicesTypesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/price_factors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalPriceFactorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"price_factors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/price_factors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalPriceFactorsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"price_factors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/public/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalPublicInfoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/public/inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalPublicInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/public/inspections/:inspection_id/document_types(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalPublicInspectionDocumentTypesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/public/inspections/:inspection_id/documents(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalPublicInspectionDocumentsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalReportsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/signatures/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalSignaturePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/technicians/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalTechnicianPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/technicians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalTechniciansPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"technicians"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalVisitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/visits/:visit_id/signatures(.:format)
 * @param {any} visitId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalVisitSignaturesPath = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/attachments/:id(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderAttachmentPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/attachments(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderAttachmentsPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/building_notes(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderBuildingNotesPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"building_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/deficiencies(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderDeficienciesPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/documents/:id(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderDocumentPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/document_types(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderDocumentTypesPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/documents(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderDocumentsPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/invoices(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderInvoicesPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_order_line_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderLineItemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_order_line_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/materials_and_services/:id(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderMaterialsAndServicePath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"materials_and_services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/materials_and_services(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderMaterialsAndServicesPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"materials_and_services"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/related_items(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderRelatedItemsPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"related_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/signatures(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderSignaturesPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_order_summary_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderSummaryItemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_order_summary_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/work_order_line_items(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderWorkOrderLineItemsPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"work_order_line_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/work_order_summary_items(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrderWorkOrderSummaryItemsPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"work_order_summary_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiTechnicianPortalWorkOrdersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:id/start_inspection(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1Path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start_inspection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/additional_compliance_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AdditionalComplianceAnswersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"additional_compliance_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_device_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmDeviceDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_device_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_device_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmDeviceDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_device_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/alarm_devices/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/alarm_devices(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_annunciators/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_annunciators(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcAnnunciatorsPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_control_panels/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcControlPanelPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_control_panels(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcControlPanelsPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_data_communication_links/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_data_communication_links(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcDataCommunicationLinksPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_power_supplies(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcPowerSuppliesPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_power_supplies/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_printers/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcPrinterPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_printers(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcPrintersPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_printers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_remote_trouble_signal_units/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_remote_trouble_signal_units(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcRemoteTroubleSignalUnitsPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_voice_communications/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_voice_communications(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemUlcVoiceCommunicationsPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AlarmSystemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AnswerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AnswersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AssetsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/audibility_test_reading_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AudibilityTestReadingDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"audibility_test_reading_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/audibility_test_reading_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1AudibilityTestReadingDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"audibility_test_reading_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/back_flows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1BackFlowPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/back_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1BackFlowsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"back_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1BuildingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/building_contacts(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1BuildingBuildingContactsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:building_id/invoices(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1BuildingInvoicesPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/building_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1BuildingNotePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/building_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1BuildingNotesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1BuildingsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CalendarEventsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clean_agent_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CleanAgentSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clean_agent_systems/:clean_agent_system_id/alarm_devices/:id(.:format)
 * @param {any} cleanAgentSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CleanAgentSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"clean_agent_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clean_agent_systems/:clean_agent_system_id/alarm_devices(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CleanAgentSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"clean_agent_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clean_agent_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CleanAgentSystemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/contacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ContactPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ContactsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/control_panels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ControlPanelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/control_panel_reading_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ControlPanelReadingDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"control_panel_reading_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/control_panel_reading_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ControlPanelReadingDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"control_panel_reading_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/control_panels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ControlPanelsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"control_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/custom_inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CustomInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/custom_inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CustomInspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"custom_inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cylinder_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CylinderDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cylinder_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cylinder_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1CylinderDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cylinder_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/deactivate_object(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DeactivateObjectPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deactivate_object"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/default_technician_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DefaultTechnicianNotesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"default_technician_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DeficiencyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dry_valve_answer_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DryValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dry_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dry_valve_answer_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1DryValveAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dry_valve_answer_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/equipment_inspection_info_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EquipmentInspectionInfoPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"equipment_inspection_info_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/equipment_inspection_info_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1EquipmentInspectionInfoPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"equipment_inspection_info_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/external_forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ExternalFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"external_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/external_forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ExternalFormsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"external_forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_dampers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDamperPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_damper_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDamperDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_damper_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_damper_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDamperDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_damper_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_dampers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDampersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_dampers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_doors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDoorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_door_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDoorDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_door_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDoorDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_door_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDoorGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_door_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDoorGroupsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_doors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireDoorsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_doors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_signs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExitSignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_sign_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExitSignDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_sign_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExitSignDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_sign_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_sign_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExitSignGroupsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_signs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExitSignsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_extinguishers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExtinguisherPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_extinguisher_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_extinguisher_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExtinguisherGroupsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_extinguishers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireExtinguishersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_hose_answer_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireHoseAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_hose_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_hose_answer_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FireHoseAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_hose_answer_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/formlink/forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FormlinkFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"formlink"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/formlink/form_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FormlinkFormTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"formlink"],[2,[7,"/"],[2,[6,"form_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/formlink/forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FormlinkFormsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"formlink"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/formlink/inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FormlinkInspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"formlink"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FormsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/generic_answer_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1GenericAnswerPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"generic_answer_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/generic_answer_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1GenericAnswerPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"generic_answer_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/generic_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1GenericQuestionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"generic_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/hose_valve_answer_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1HoseValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"hose_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/hose_valve_answer_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1HoseValveAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"hose_valve_answer_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionAnswerPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionAnswersPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_attachments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionAttachmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionAttachmentsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_custom_inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionCustomInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_custom_inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_custom_inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionCustomInspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_custom_inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/deficiencies(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionDeficienciesPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/deficiencies/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionDeficiencyPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_external_forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionExternalFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_external_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_external_form_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionExternalFormDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_external_form_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_external_form_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionExternalFormDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_external_form_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_external_forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionExternalFormsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_external_forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/inspection_visits/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionInspectionVisitPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/inspection_visits(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionInspectionVisitsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:id/update_scheduled_date_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionUpdateScheduledDateInfoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_scheduled_date_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:id/upload_complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionUploadCompletePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspectors_test_valve_answer_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectorsTestValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspectors_test_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspectors_test_valve_answer_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InspectorsTestValveAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspectors_test_valve_answer_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/internal_check_valve_five_year_answer_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InternalCheckValveFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"internal_check_valve_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/internal_check_valve_five_year_answer_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InternalCheckValveFiveYearAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"internal_check_valve_five_year_answer_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/internal_pipe_five_year_answer_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InternalPipeFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"internal_pipe_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/internal_pipe_five_year_answer_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1InternalPipeFiveYearAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"internal_pipe_five_year_answer_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/materials/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1MaterialPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/materials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1MaterialsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"materials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/monitoring_devices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1MonitoringDevicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"monitoring_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/monitoring_devices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1MonitoringDevicesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"monitoring_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/monitoring_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1MonitoringSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/monitoring_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1MonitoringSystemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"monitoring_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pressure_reducing_valve_five_year_answer_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1PressureReducingValveFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pressure_reducing_valve_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pressure_reducing_valve_five_year_answer_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1PressureReducingValveFiveYearAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pressure_reducing_valve_five_year_answer_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ProfileIndexPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/proposals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ProposalPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/proposals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ProposalsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/proposed_corrections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/proposed_corrections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/signatures/:unique_id(.:format)
 * @param {any} uniqueId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SignaturePath = /*#__PURE__*/ __jsr.r({"unique_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"unique_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/signatures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SignaturesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/special_hazards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SpecialHazardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/special_hazards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SpecialHazardsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"special_hazards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sprinkler_heads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SprinklerHeadPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sprinkler_heads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SprinklerHeadsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SystemQuestionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SystemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/v1/time_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1TimeEntriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/v1/time_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1TimeEntryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_ancillary_device_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcAncillaryDeviceDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_ancillary_device_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_ancillary_device_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcAncillaryDeviceDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_ancillary_device_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_annunciators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_annunciators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcAnnunciatorsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_control_panels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcControlPanelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_control_panels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcControlPanelsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_data_communication_links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_data_communication_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcDataCommunicationLinksPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_power_supplies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcPowerSuppliesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_power_supplies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_printers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcPrinterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_printers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcPrintersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_printers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_remote_trouble_signal_units/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_remote_trouble_signal_units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcRemoteTroubleSignalUnitsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_voice_communications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_voice_communications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1UlcVoiceCommunicationsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/valve_answer_deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"valve_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/valve_answer_deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1ValveAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"valve_answer_deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1VideoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1VideosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1VisitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1VisitsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/:work_order_id/invoices/:id(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderInvoicePath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/:work_order_id/invoices(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderInvoicesPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/:work_order_id/service_visits/:id(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderServiceVisitPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"service_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/:work_order_id/service_visits(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderServiceVisitsPath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"service_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderVideoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrderVideosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrdersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1WorkOrdersAttachmentsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2AlarmSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/:alarm_system_id/alarm_devices/:id(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2AlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/:alarm_system_id/alarm_devices(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2AlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2AlarmSystemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/config/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2ConfigSsoIndexPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"config"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2ConfigsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/deficiency_photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2DeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/deficiency_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2DeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/time_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2TimeEntriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV2VisitsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/alarm_device_catalogs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3AlarmDeviceCatalogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/alarm_device_catalogs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3AlarmDeviceCatalogsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3InspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3InspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/price_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3PriceListsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"price_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/react_example(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3ReactExamplePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"react_example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/remarks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3RemarksPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"remarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/swap_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3SwapItemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"swap_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/swap_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3SwapItemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"swap_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/technicians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV3TechniciansPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"technicians"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveSubcontractorInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/work_orders/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveSubcontractorWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_lists/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archivePriceListPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/emergency_generator_infos/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetEmergencyGeneratorInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"emergency_generator_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/emergency_generator_infos(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetEmergencyGeneratorInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"emergency_generator_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hoses/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFireHosePath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hoses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hoses(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFireHosesPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hoses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hydrant_infos/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFireHydrantInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hydrant_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hydrant_infos(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFireHydrantInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hydrant_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_pump_infos/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFirePumpInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_pump_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_pump_infos(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFirePumpInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_pump_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/foam_water_infos/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFoamWaterInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"foam_water_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/foam_water_infos(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFoamWaterInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"foam_water_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fuel_tank_infos/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFuelTankInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fuel_tank_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fuel_tank_infos(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetFuelTankInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fuel_tank_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/hose_valves/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetHoseValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"hose_valves"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/hose_valves(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetHoseValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"hose_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/kitchen_hood_infos/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetKitchenHoodInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"kitchen_hood_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/kitchen_hood_infos(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetKitchenHoodInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"kitchen_hood_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/paint_spray_booth_infos/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetPaintSprayBoothInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"paint_spray_booth_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/paint_spray_booth_infos(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetPaintSprayBoothInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"paint_spray_booth_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/transfer_switch_infos/:id(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetTransferSwitchInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"transfer_switch_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/transfer_switch_infos(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetTransferSwitchInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"transfer_switch_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/:id/associate_to_building(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associateToBuildingProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_to_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/attachment_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentCategoriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"attachment_categories"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/attachment_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachmentCategoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"attachment_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/auth_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authCallbackTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"auth_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/time_entries/available_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availableJobsApiV2TimeEntriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"available_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/avalara_tax(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avalaraTaxPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"avalara_tax"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_certifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowCertificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_certifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_certifications/:back_flow_certification_id/show_modal(.:format)
 * @param {any} backFlowCertificationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowCertificationShowModalPath = /*#__PURE__*/ __jsr.r({"locale":{},"back_flow_certification_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_certifications"],[2,[7,"/"],[2,[3,"back_flow_certification_id"],[2,[7,"/"],[2,[6,"show_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_certifications/:back_flow_certification_id/update_modal_view(.:format)
 * @param {any} backFlowCertificationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowCertificationUpdateModalViewPath = /*#__PURE__*/ __jsr.r({"locale":{},"back_flow_certification_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_certifications"],[2,[7,"/"],[2,[3,"back_flow_certification_id"],[2,[7,"/"],[2,[6,"update_modal_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_certifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowCertificationsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_certifications"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_test_kits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowTestKitPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_test_kits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_test_kits/:back_flow_test_kit_id/show_modal(.:format)
 * @param {any} backFlowTestKitId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowTestKitShowModalPath = /*#__PURE__*/ __jsr.r({"locale":{},"back_flow_test_kit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_test_kits"],[2,[7,"/"],[2,[3,"back_flow_test_kit_id"],[2,[7,"/"],[2,[6,"show_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_test_kits/:back_flow_test_kit_id/update_modal_view(.:format)
 * @param {any} backFlowTestKitId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowTestKitUpdateModalViewPath = /*#__PURE__*/ __jsr.r({"locale":{},"back_flow_test_kit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_test_kits"],[2,[7,"/"],[2,[3,"back_flow_test_kit_id"],[2,[7,"/"],[2,[6,"update_modal_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_test_kits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowTestKitsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_test_kits"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backFlowsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flows"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/backflows_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backflowsReportAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"backflows_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/backflows_report_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backflowsReportCsvAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"backflows_report_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/document_types/batch_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchUpdateSubcontractorDocumentTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[6,"batch_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/billing_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingReportTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"billing_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/signatures/blurbs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blurbsApiTechnicianPortalSignaturesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[6,"blurbs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/browser_not_supported(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browserNotSupportedPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"browser_not_supported"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/documentation/build_files_select_for_category(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildFilesSelectForCategorySubcontractorDocumentationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[6,"build_files_select_for_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/alarm_systems(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingAlarmSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"alarm_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/alarm_systems/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingAlarmSystemsListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/areas/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingAreaPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/areas(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingAreasPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/assets/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingAssetPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/assets(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingAssetsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/assets/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingAssetsListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/back_flows/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBackFlowPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/back_flows(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBackFlowsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"back_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/attachments/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/attachments(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingAttachmentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_dry_valves/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingDryValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_dry_valves"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_dry_valves(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingDryValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_dry_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_notes/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_notes(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingNotesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_reminders/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingReminderPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_reminders(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingRemindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_sections/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_sections(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingBuildingSectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/clean_agent_systems/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingCleanAgentSystemsListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/contacts/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/contacts(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingContactsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/deficiencies(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/deficiencies/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/building_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingDetailsInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"building_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/building_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingDetailsProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"building_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_dry_valves/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingDryValvesListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_dry_valves"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_dry_valves/mass_edit(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingDryValvesMassEditPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_dry_valves"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_dry_valves/mass_update(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingDryValvesMassUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_dry_valves"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/equipments/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingEquipmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/equipments(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingEquipmentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"equipments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/equipments/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingEquipmentsListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/equipments/mass_edit(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingEquipmentsMassEditPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/equipments/mass_update(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingEquipmentsMassUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_dampers/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingFireDamperPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_dampers(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingFireDampersPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_dampers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_door_groups/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingFireDoorGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_door_groups(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingFireDoorGroupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_door_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_exit_sign_groups/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingFireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_exit_sign_groups(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingFireExitSignGroupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_extinguisher_groups/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingFireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_extinguisher_groups(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingFireExtinguisherGroupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/valves(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectionSeriesIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_templates/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectionTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_templates(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectionTemplatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspectors_test_valves/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectorsTestValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspectors_test_valves(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectorsTestValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspectors_test_valves(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectorsTestValvesIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspectors_test_valves/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectorsTestValvesListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspectors_test_valves/mass_building_edit(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectorsTestValvesMassEditPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[6,"mass_building_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspectors_test_valves/mass_building_update(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingInspectorsTestValvesMassUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[6,"mass_building_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/notes/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/notes(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingNotesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/reports/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/reports(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/sales_people(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingSalesPeoplePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"sales_people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/sales_people/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingSalesPersonPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"sales_people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/smoke_cos(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingSmokeCosPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"smoke_cos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/smoke_cos/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingSmokeCosListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/special_hazards/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingSpecialHazardsListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/systems/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/systems(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/systems/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingSystemsListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series/update_frequencies(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingUpdateFrequenciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[6,"update_frequencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/valves/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/valves(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/valves/listing(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingValvesListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/valves/mass_building_edit(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingValvesMassEditPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[6,"mass_building_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/valves/mass_building_update(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingValvesMassUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[6,"mass_building_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/create_service_trade(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildingsCreateServiceTradePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"create_service_trade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_offs/bulk_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDestroyTimeOffsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_offs"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/:alarm_system_id/alarm_devices/bulk_inspect(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkInspectApiV2AlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"bulk_inspect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/bulk_invite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkInviteContactsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"bulk_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkPaymentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/deficiencies/bulk_resolve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkResolveApiTechnicianPortalDeficienciesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"bulk_resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendarPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendarInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelCustomerRegistrationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractors/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelSubcontractorPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelUserRegistrationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/:id/change_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changePasswordTechnicianPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/change_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changePasswordUserPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/charge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chargePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"charge"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/check_any_similar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkAnySimilarApiV1BuildingsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"check_any_similar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/check_available(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkAvailableTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"check_available"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/choose_building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chooseBuildingWorkOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"choose_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/alarm_devices/:id(.:format)
 * @param {any} cleanAgentSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/alarm_devices(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/control_panels/:id(.:format)
 * @param {any} cleanAgentSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/control_panels(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemControlPanelsPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"control_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/cylinders/:id(.:format)
 * @param {any} cleanAgentSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemCylinderPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/cylinders(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemCylindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"cylinders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_system_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_system_question_sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_system_question_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_system_question_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemQuestionSectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_system_question_sections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanAgentSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/code_years/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const codeYearPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"code_years"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/code_years(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const codeYearsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"code_years"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/collection_for_select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collectionForSelectAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"collection_for_select"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_holidays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyHolidayPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_holidays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_holidays(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyHolidaysPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_holidays"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companySettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/internal/integrations/planhat/company_webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyWebhookApiInternalIntegrationsPlanhatIndexPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"planhat"],[2,[7,"/"],[2,[6,"company_webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/visits/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeApiTechnicianPortalVisitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/confirm_inspection_price(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmInspectionPriceInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_inspection_price"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/conflicts_listing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conflictsListingInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"conflicts_listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/dashboard/contact_us(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactUsCustomerPortalDashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"contact_us"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/control_panel_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const controlPanelTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"control_panel_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/control_panel_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const controlPanelTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"control_panel_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/copy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copyBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/copy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copyInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/:id/copy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copyProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/cost_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const costCodePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"cost_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/cost_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const costCodesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"cost_codes"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/v3/inspections/:inspection_id/additional_technicians/create_batch(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createBatchApiV3InspectionAdditionalTechniciansPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"additional_technicians"],[2,[7,"/"],[2,[6,"create_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/create_building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createBuildingProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"create_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/create_contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createContactProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"create_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal/templates/create_from_proposal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createFromProposalProposalsTemplatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"create_from_proposal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/create_new_proposals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createNewProposalsProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"create_new_proposals"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/inspection_id/:inspection_id/:report_type/:inspectable_type/:inspectable_id(.:format)
 * @param {any} inspectionId
 * @param {any} reportType
 * @param {any} inspectableType
 * @param {any} inspectableId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPartialReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"report_type":{"r":true},"inspectable_type":{"r":true},"inspectable_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"inspection_id"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[3,"report_type"],[2,[7,"/"],[2,[3,"inspectable_type"],[2,[7,"/"],[2,[3,"inspectable_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/create_payment_record(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPaymentRecordPaymentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"create_payment_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/create_payrix_payment_record(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createPayrixPaymentRecordPaymentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"create_payrix_payment_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/create_report_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createReportDataIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"create_report_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/create_report_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createReportDataTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"create_report_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/inspection_id/:inspection_id/:report_type(.:format)
 * @param {any} inspectionId
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"report_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"inspection_id"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/create_suggested_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createSuggestedAccountsAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"create_suggested_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/create_text_record(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTextRecordProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"create_text_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_offs/create_time_off_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTimeOffTypeTimeOffsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_offs"],[2,[7,"/"],[2,[6,"create_time_off_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/import/csv(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csvAlarmSystemImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/import/csv_esp(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csvEspAlarmSystemImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"csv_esp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/csvbox_failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csvboxFailurePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"csvbox_failure"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/csvbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csvboxHelperPagePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"csvbox"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/csvbox_success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csvboxSuccessPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"csvbox_success"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/currencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const currencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"currencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/custom_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customCreateUsersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"custom_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_fields_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customFieldsTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_fields_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_fields_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customFieldsTemplatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_fields_templates"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:custom_inspection_id/custom_inspection_sections/:id(.:format)
 * @param {any} customInspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customInspectionCustomInspectionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"custom_inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"custom_inspection_id"],[2,[7,"/"],[2,[6,"custom_inspection_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:custom_inspection_id/custom_inspection_sections(.:format)
 * @param {any} customInspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customInspectionCustomInspectionSectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"custom_inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"custom_inspection_id"],[2,[7,"/"],[2,[6,"custom_inspection_sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:custom_inspection_id/questions/:id(.:format)
 * @param {any} customInspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customInspectionQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"custom_inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"custom_inspection_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:custom_inspection_id/questions(.:format)
 * @param {any} customInspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customInspectionQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"custom_inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"custom_inspection_id"],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_system_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/account_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalAccountSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"account_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/buildings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/inspection_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalInspectionReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"inspection_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/proposals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/proposals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"proposals"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalRootPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/service_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalServiceReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"service_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customer_portal_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customer_portal_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/upcoming_visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalUpcomingVisitPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"upcoming_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/upcoming_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerPortalUpcomingVisitsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"upcoming_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerRegistrationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerRootPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/quick_books_session/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customersQuickBooksSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"quick_books_session"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/dashboard_edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardEditUsersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"dashboard_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractors/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardSubcontractorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/datatable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datatableBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"datatable"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/datatable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datatableDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"datatable"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/datatable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datatableInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"datatable"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/datatable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datatableReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"datatable"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractors/datatable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datatableSubcontractorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[6,"datatable"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/time_entries/day_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dayViewApiV2TimeEntriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"day_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivateAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivateBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/invites/:token/decline(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declineSubcontractorInvitePath = /*#__PURE__*/ __jsr.r({"locale":{},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/default_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const defaultEmailIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"default_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/default_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const defaultEmailTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"default_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/default_technician_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const defaultTechnicianNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"default_technician_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/default_technician_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const defaultTechnicianNotesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"default_technician_notes"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies_ai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficienciesAiPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies_ai"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/deficiencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficienciesDashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/deficiency_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficiencyDashboardAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"deficiency_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiency_report_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficiencyReportNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiency_report_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiency_report_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficiencyReportNotesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiency_report_notes"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiency_resolution_statuses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficiencyResolutionStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiency_resolution_statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiency_resolution_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficiencyResolutionStatusesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiency_resolution_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/deficiencies/deficiency_resolution_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deficiencyResolutionStatusesExternalApiV1DeficienciesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"deficiency_resolution_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/delete_building_duplicates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteBuildingDuplicatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"delete_building_duplicates"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/map/delete_fleet_tracking_passengers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteFleetTrackingPassengersMapPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"delete_fleet_tracking_passengers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/delete_sp_duplicates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteSpDuplicatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"delete_sp_duplicates"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/delete_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteTokenIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"delete_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/delete_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteTokenTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"delete_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_lists/:id/dependencies(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dependenciesPriceListPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_settings/destroy_additional_timezone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAdditionalTimezoneCompanySettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_settings"],[2,[7,"/"],[2,[6,"destroy_additional_timezone"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyCustomerSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:id/destroy_header_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyHeaderImageCustomInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_header_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_reports/destroy_proposal_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyProposalReportProposalReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_reports"],[2,[7,"/"],[2,[6,"destroy_proposal_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyTechnicianSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:id/download_corrective_form(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCorrectiveFormWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_corrective_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/download_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCsvInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/download_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadCsvWorkOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/download_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadInvoicesInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"download_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/service_reports/:id/download_link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadLinkCustomerPortalServiceReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"service_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/download_qwc_file(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadQwcFileQbdSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[6,"download_qwc_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/:id/download_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadReportProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/driver_associations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const driverAssociationsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"driver_associations"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/report_settings/drop_cover_letter_signature(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dropCoverLetterSignatureReportSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"report_settings"],[2,[7,"/"],[2,[6,"drop_cover_letter_signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_lists/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicatePriceListPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tax_items/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateTaxItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tax_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/invites/:token/easy_upload_accept(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const easyUploadAcceptSubcontractorInvitePath = /*#__PURE__*/ __jsr.r({"locale":{},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"easy_upload_accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/invites/:token/easy_upload_acceptance(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const easyUploadAcceptanceSubcontractorInvitePath = /*#__PURE__*/ __jsr.r({"locale":{},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"easy_upload_acceptance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/account_info/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccountInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"account_info"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_answer_deficiencies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmDeviceAnswerDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_answer_deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_catalogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmDeviceCatalogPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmDeviceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/control_panels/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_system_deficiencies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_system_deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/device_legends/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemDeviceLegendPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"device_legends"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_ancillary_devices/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemUlcAncillaryDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_ancillary_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_annunciators/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemUlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_control_panels/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemUlcControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_data_communication_links/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemUlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_power_supplies/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemUlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_printers/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemUlcPrinterPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_remote_trouble_signal_units/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemUlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_voice_communications/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlarmSystemUlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alternate_headers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAlternateHeaderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alternate_headers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answer_choices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAnswerChoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answer_choices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api_keys/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiKeyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalBuildingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/contacts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalContactPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/deficiencies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalDeficiencyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalDocumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/document_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalDocumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalInvoicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalMaterialsAndServicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalMaterialsAndServicesTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/price_factors/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalPriceFactorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"price_factors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/technicians/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalTechnicianPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalWorkOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/materials_and_services/:id/edit(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiTechnicianPortalWorkOrderMaterialsAndServicePath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"materials_and_services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_device_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmDeviceDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_device_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/alarm_devices/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_annunciators/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemUlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_control_panels/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemUlcControlPanelPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_data_communication_links/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemUlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_power_supplies/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemUlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_printers/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemUlcPrinterPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_remote_trouble_signal_units/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemUlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_voice_communications/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AlarmSystemUlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AnswerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/assets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/audibility_test_reading_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1AudibilityTestReadingDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"audibility_test_reading_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/back_flows/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1BackFlowPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1BuildingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/building_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1BuildingNotePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clean_agent_systems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1CleanAgentSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clean_agent_systems/:clean_agent_system_id/alarm_devices/:id/edit(.:format)
 * @param {any} cleanAgentSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1CleanAgentSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"clean_agent_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/contacts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1ContactPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/control_panel_reading_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1ControlPanelReadingDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"control_panel_reading_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/custom_inspections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1CustomInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cylinder_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1CylinderDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cylinder_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1DeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dry_valve_answer_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1DryValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dry_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/equipment_inspection_info_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1EquipmentInspectionInfoPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"equipment_inspection_info_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/external_forms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1ExternalFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"external_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_dampers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireDamperPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_damper_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireDamperDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_damper_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_doors/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireDoorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_door_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireDoorDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_door_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireDoorGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_signs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireExitSignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_sign_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireExitSignDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_sign_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_extinguishers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireExtinguisherPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_extinguisher_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_hose_answer_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FireHoseAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_hose_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1FormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/generic_answer_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1GenericAnswerPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"generic_answer_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/hose_valve_answer_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1HoseValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"hose_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectionAnswerPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_attachments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectionAttachmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_custom_inspections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectionCustomInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_custom_inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/deficiencies/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectionDeficiencyPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectionDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_external_forms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectionExternalFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_external_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_external_form_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectionExternalFormDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_external_form_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspectors_test_valve_answer_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InspectorsTestValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspectors_test_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/internal_check_valve_five_year_answer_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InternalCheckValveFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"internal_check_valve_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/internal_pipe_five_year_answer_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1InternalPipeFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"internal_pipe_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/materials/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1MaterialPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pressure_reducing_valve_five_year_answer_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1PressureReducingValveFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pressure_reducing_valve_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/proposals/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1ProposalPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/proposed_corrections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1ProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/special_hazards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1SpecialHazardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sprinkler_heads/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1SprinklerHeadPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/systems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1SystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_ancillary_device_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1UlcAncillaryDeviceDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_ancillary_device_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_annunciators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1UlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_control_panels/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1UlcControlPanelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_data_communication_links/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1UlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_power_supplies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1UlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_printers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1UlcPrinterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_remote_trouble_signal_units/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1UlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_voice_communications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1UlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/valve_answer_deficiency_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1ValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"valve_answer_deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/videos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1VideoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/visits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1VisitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1WorkOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_photos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1WorkOrderPhotoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_videos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV1WorkOrderVideoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV2AlarmSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/:alarm_system_id/alarm_devices/:id/edit(.:format)
 * @param {any} alarmSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV2AlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/alarm_device_catalogs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV3AlarmDeviceCatalogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/swap_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiV3SwapItemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"swap_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/emergency_generator_infos/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetEmergencyGeneratorInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"emergency_generator_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hoses/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetFireHosePath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hoses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hydrant_infos/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetFireHydrantInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hydrant_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_pump_infos/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetFirePumpInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_pump_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/foam_water_infos/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetFoamWaterInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"foam_water_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fuel_tank_infos/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetFuelTankInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fuel_tank_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/hose_valves/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetHoseValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"hose_valves"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/kitchen_hood_infos/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetKitchenHoodInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"kitchen_hood_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/paint_spray_booth_infos/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetPaintSprayBoothInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"paint_spray_booth_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/transfer_switch_infos/:id/edit(.:format)
 * @param {any} assetId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAssetTransferSwitchInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"transfer_switch_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/attachment_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAttachmentCategoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"attachment_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flows/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBackFlowPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_certifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBackFlowCertificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_certifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_test_kits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBackFlowTestKitPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_test_kits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/areas/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingAreaPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/assets/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingAssetPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/back_flows/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingBackFlowPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/attachments/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingBuildingAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_dry_valves/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingBuildingDryValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_dry_valves"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_notes/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingBuildingNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_reminders/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingBuildingReminderPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_reminders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_sections/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingBuildingSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/contacts/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/deficiencies/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/equipments/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingEquipmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_dampers/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingFireDamperPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_door_groups/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingFireDoorGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_exit_sign_groups/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingFireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_extinguisher_groups/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingFireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_templates/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingInspectionTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspectors_test_valves/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingInspectorsTestValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/notes/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/reports/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/sales_people/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingSalesPersonPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"sales_people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/systems/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/valves/:id/edit(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBuildingValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCleanAgentSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/alarm_devices/:id/edit(.:format)
 * @param {any} cleanAgentSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCleanAgentSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/control_panels/:id/edit(.:format)
 * @param {any} cleanAgentSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCleanAgentSystemControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/cylinders/:id/edit(.:format)
 * @param {any} cleanAgentSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCleanAgentSystemCylinderPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_system_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCleanAgentSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_system_question_sections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCleanAgentSystemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_system_question_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/code_years/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCodeYearPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"code_years"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_holidays/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCompanyHolidayPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_holidays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/control_panel_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editControlPanelTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"control_panel_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/cost_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCostCodePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"cost_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_fields_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomFieldsTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_fields_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:custom_inspection_id/custom_inspection_sections/:id/edit(.:format)
 * @param {any} customInspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomInspectionCustomInspectionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"custom_inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"custom_inspection_id"],[2,[7,"/"],[2,[6,"custom_inspection_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:custom_inspection_id/questions/:id/edit(.:format)
 * @param {any} customInspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomInspectionQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"custom_inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"custom_inspection_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_system_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCustomerRegistrationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/default_technician_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDefaultTechnicianNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"default_technician_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiency_report_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDeficiencyReportNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiency_report_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiency_resolution_statuses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDeficiencyResolutionStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiency_resolution_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEquipmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_deficiencies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEquipmentDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment/:equipment_id/equipment_top_level_attributes/:id/edit(.:format)
 * @param {any} equipmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEquipmentEquipmentTopLevelAttributePath = /*#__PURE__*/ __jsr.r({"locale":{},"equipment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"equipment_id"],[2,[7,"/"],[2,[6,"equipment_top_level_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_inspection_infos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEquipmentInspectionInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_inspection_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_statuses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEquipmentStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEquipmentTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/exclusions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExclusionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"exclusions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series/:id/edit_expiring_inspection_series(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExpiringInspectionSeriesBuildingInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_expiring_inspection_series"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1BuildingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/building_tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1BuildingTagPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/contacts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1ContactPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1InspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspection_visits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1InspectionVisitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1InvoicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/proposed_corrections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1ProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/teams/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1TeamPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/territories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1TerritoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"territories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/webhook_endpoints/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalApiV1WebhookEndpointPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook_endpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/external_forms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalFormPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"external_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/external_form_pdf_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editExternalFormPdfAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"external_form_pdf_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireAlarmAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_system_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireAlarmSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_system_question_sections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireAlarmSystemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_system_question_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_dampers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireDamperPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_damper_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireDamperAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireDoorAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireDoorGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:fire_door_group_id/fire_doors/:id/edit(.:format)
 * @param {any} fireDoorGroupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireDoorGroupFireDoorPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"fire_door_group_id"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_system_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireDoorSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExitSignAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs/:id/edit(.:format)
 * @param {any} fireExitSignGroupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExitSignGroupFireExitSignPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_manufacturers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExitSignManufacturerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_manufacturers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_system_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExitSignSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExitSignTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguishers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_deficiencies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/fire_extinguishers/:id/edit(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherGroupFireExtinguisherPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_makes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherMakePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_makes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_swap_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherSwapItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_swap_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_system_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_weights/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFireExtinguisherWeightPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_weights"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/generic_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGenericAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_questions/:id/edit(.:format)
 * @param {any} objectType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGenericQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_question_sections/:id/edit(.:format)
 * @param {any} objectType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGenericQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_question_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/alarm_device_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionAlarmDeviceAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"alarm_device_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/attachments/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/audibility_test_readings/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionAudibilityTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"audibility_test_readings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/circuit_fault_tolerance_test_readings/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionCircuitFaultToleranceTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"circuit_fault_tolerance_test_readings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/control_panel_readings/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionControlPanelReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"control_panel_readings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/cylinder_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionCylinderAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"cylinder_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/dry_valve_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionDryValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"dry_valve_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/equipment_inspection_infos/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionEquipmentInspectionInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipment_inspection_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_alarm_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionFireAlarmAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_damper_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionFireDamperAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_door_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionFireDoorAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_exit_sign_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionFireExitSignAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_extinguisher_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionFireExtinguisherAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_hose_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionFireHoseAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_hose_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/generic_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionGenericAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/hose_valve_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionHoseValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"hose_valve_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_asset_proposed_corrections/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionInspectionAssetProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_asset_proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_proposed_corrections/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionInspectionProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_system_proposed_corrections/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionInspectionSystemProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_system_proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspectors_test_valve_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionInspectorsTestValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspectors_test_valve_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/non_life_safety_circuit_supervision_test_readings/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionNonLifeSafetyCircuitSupervisionTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"non_life_safety_circuit_supervision_test_readings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/proposal_inclusions/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionProposalInclusionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"proposal_inclusions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/proposal_line_items/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionProposalLineItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"proposal_line_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/remarks/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionRemarkPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"remarks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/signatures/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionSignaturePath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection/statuses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection"],[2,[7,"/"],[2,[6,"statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_status_notifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionStatusNotificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_status_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/subsequent_alarm_control_panel_test_readings/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionSubsequentAlarmControlPanelTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"subsequent_alarm_control_panel_test_readings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/system_questions/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/ulc_ancillary_device_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionUlcAncillaryDeviceAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"ulc_ancillary_device_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/valve_answers/:id/edit(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"valve_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:id/edit_inspection_work_order(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInspectionWorkOrderWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_inspection_work_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal_check_valve_five_year_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalCheckValveFiveYearAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal_check_valve_five_year_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal_pipe_five_year_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalPipeFiveYearAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal_pipe_five_year_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inventory_sources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInventorySourcePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inventory_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:invoice_id/attachments/:id/edit(.:format)
 * @param {any} invoiceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInvoiceAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"invoice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoice_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInvoiceCategoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoice_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/logos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLogoPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"logos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/map/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMapPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMaterialPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/material_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMaterialTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"material_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_used/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMaterialsUsedPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_used"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMonitoringSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:monitoring_system_id/devices/:id/edit(.:format)
 * @param {any} monitoringSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMonitoringSystemDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"monitoring_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"monitoring_system_id"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems_device_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMonitoringSystemsDeviceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems_device_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payment_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPaymentSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payment_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payment_terms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPaymentTermPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payment_terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/pressure_reducing_valve_five_year_answers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPressureReducingValveFiveYearAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"pressure_reducing_valve_five_year_answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_factors/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProposalFactorPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_factors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_statuses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProposalStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProposalTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal/templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProposalsTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProposedCorrectionTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/public_passwords/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPublicPasswordsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"public_passwords"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editQbdSettingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sandbox/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSandboxPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sandbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/scope_of_works/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editScopeOfWorkPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"scope_of_works"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServiceTradePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editServiceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSmokeCOPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/alarm_devices/:id/edit(.:format)
 * @param {any} smokeCOId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSmokeCOAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/aerosol_hazard_infos/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardAerosolHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"aerosol_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/alarm_devices/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cartridges/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardCartridgePath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cartridges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/clean_agent_hazard_infos/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardCleanAgentHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"clean_agent_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/co2_hazard_infos/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardCO2HazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"co2_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/control_panels/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cylinders/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardCylinderPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/halon_hazard_infos/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardHalonHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"halon_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazard_system_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazard_system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/vehicle_suppression_hazard_infos/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardVehicleSuppressionHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"vehicle_suppression_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_hazard_infos/:id/edit(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardWaterMistHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_pumps/edit(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardWaterMistPumpsPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_pumps"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_valves/edit(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardWaterMistValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_valves"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/zones/edit(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSpecialHazardZonesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series/:id/edit_status(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editStatusBuildingInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractors/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSubcontractorPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/summaries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSummaryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"summaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/dry_valves/:id/edit(.:format)
 * @param {any} systemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSystemDryValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"dry_valves"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/inspectors_test_valves/:id/edit(.:format)
 * @param {any} systemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSystemInspectorsTestValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_question_sections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSystemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_question_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/sprinkler_heads/:id/edit(.:format)
 * @param {any} systemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSystemSprinklerHeadPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/valves/:id/edit(.:format)
 * @param {any} systemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSystemValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tag_colors/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTagColorPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tag_colors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tax_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tax_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tax_rates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxRatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/teams/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTeamPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTechnicianPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technician_day_offs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTechnicianDayOffPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technician_day_offs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTechnicianPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/terms_and_conditions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTermsAndConditionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"terms_and_conditions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/territories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTerritoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"territories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entries/tracked_object/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTimeEntriesTrackedObjectPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"tracked_object"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTimeEntryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entry_rates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTimeEntryRatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entry_rates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/top_level_attributes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTopLevelAttributePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"top_level_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserRegistrationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editVisitPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visit_statuses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editVisitStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visit_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_corrections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_corrections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_default_followups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderDefaultFollowupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_default_followups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_line_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderLineItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_line_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_statuses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_summary_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderSummaryItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_summary_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/work_order_signatures/:id/edit(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editWorkOrderWorkOrderSignaturePath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"work_order_signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/email_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailModalProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"email_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const entitiesIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/envelope_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const envelopePageInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"envelope_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_deficiencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment/:equipment_id/equipment_top_level_attributes/:id(.:format)
 * @param {any} equipmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentEquipmentTopLevelAttributePath = /*#__PURE__*/ __jsr.r({"locale":{},"equipment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"equipment_id"],[2,[7,"/"],[2,[6,"equipment_top_level_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment/:equipment_id/equipment_top_level_attributes(.:format)
 * @param {any} equipmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentEquipmentTopLevelAttributesPath = /*#__PURE__*/ __jsr.r({"locale":{},"equipment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"equipment_id"],[2,[7,"/"],[2,[6,"equipment_top_level_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_inspection_infos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentInspectionInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_inspection_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_inspection_infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentInspectionInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_inspection_infos"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_statuses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentStatusesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_questions/equipment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[6,"equipment"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipmentTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/import/est_four(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estFourAlarmSystemImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"est_four"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/import/est_three_brc(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estThreeBRCAlarmSystemImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"est_three_brc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/exclusions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exclusionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"exclusions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/exclusions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exclusionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"exclusions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/expiring_inspection_series_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expiringInspectionSeriesReportInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"expiring_inspection_series_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_catalogs/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAlarmDeviceCatalogsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices/export(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportAlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entries/export_computerease_payroll_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportComputereasePayrollCsvTimeEntriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"export_computerease_payroll_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/export_computerease_xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportComputereaseXmlInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"export_computerease_xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvContactsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguishers/export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvFireExtinguishersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials/export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvMaterialsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entries/export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvTimeEntriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguishers/export_csv_with_buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvWithBuildingsFireExtinguishersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"export_csv_with_buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/export_detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportDetailInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"export_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/export_sage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportSageInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"export_sage"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguishers/export_summary_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportSummaryCsvFireExtinguishersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"export_summary_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/export_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportSummaryInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"export_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_offs/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportTimeOffsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_offs"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/work_orders/:id/update_technician(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1Path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_technician"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1AccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1AccountsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/alarm_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1AlarmSystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/alarm_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1AlarmSystemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/analytics/extinguisher_projections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1AnalyticsExtinguisherProjectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"extinguisher_projections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1AssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1AssetsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/back_flows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BackFlowPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/back_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BackFlowsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"back_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/alarm_systems(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingAlarmSystemsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"alarm_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/assets(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingAssetsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/back_flows(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingBackFlowsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"back_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/building_contacts(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingBuildingContactsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/building_sales_people(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingBuildingSalesPeoplePath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_sales_people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/fire_dampers(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingFireDampersPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_dampers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/fire_door_groups(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingFireDoorGroupsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_door_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/fire_exit_sign_groups(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingFireExitSignGroupsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/fire_extinguisher_groups(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingFireExtinguisherGroupsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/inspections/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingInspectionPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/inspection_device_types(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingInspectionDeviceTypesPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_device_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/inspection_series/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/inspection_series(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingInspectionSeriesIndexPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/inspections(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingInspectionsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/special_hazards(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingSpecialHazardsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"special_hazards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/systems(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingSystemsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/building_tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingTagPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/building_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingTagsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/work_orders/:id(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingWorkOrderPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/:building_id/work_orders(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingWorkOrdersPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1BuildingsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1CompaniesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/contacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ContactPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ContactsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/deficiencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1DeficienciesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1DeficiencyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_dampers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireDamperPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_dampers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireDampersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_dampers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_door_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireDoorGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_door_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireDoorGroupsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_exit_sign_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_exit_sign_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireExitSignGroupsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_extinguishers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireExtinguisherPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_extinguisher_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_extinguisher_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireExtinguisherGroupsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_extinguishers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1FireExtinguishersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspections/:inspection_id/status_history(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InspectionStatusHistoryIndexPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"status_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspection_visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InspectionVisitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspection_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InspectionVisitsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1IntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inventory_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InventorySourcesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inventory_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InvoicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/invoices/:invoice_id/attachments/:id(.:format)
 * @param {any} invoiceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InvoiceAttachmentPath = /*#__PURE__*/ __jsr.r({"invoice_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/invoices/:invoice_id/attachments(.:format)
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InvoiceAttachmentsPath = /*#__PURE__*/ __jsr.r({"invoice_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1InvoicesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1PaymentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1PaymentsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/price_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1PriceListPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"price_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/price_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1PriceListsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"price_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/proposals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ProposalPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/proposals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ProposalsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/proposed_corrections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/proposed_corrections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1ReportsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/special_hazards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1SpecialHazardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/special_hazards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1SpecialHazardsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"special_hazards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1SystemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1SystemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/tax_rates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TaxItemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/tax_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TaxItemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tax_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TeamPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TeamsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/technicians/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TechnicianPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/technicians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TechniciansPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"technicians"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/territories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TerritoriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"territories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/territories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TerritoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"territories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/time_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TimeEntriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/time_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1TimeEntryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1UserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1UsersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/webhook_endpoints/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1WebhookEndpointPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook_endpoints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/webhook_endpoints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1WebhookEndpointsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook_endpoints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/work_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1WorkOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/work_order_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1WorkOrderSettingsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/work_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV1WorkOrdersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/buildings/:building_id/attachments(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2BuildingAttachmentsPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/bulk_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2BulkActionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"bulk_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/bulk_operations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2BulkOperationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"bulk_operations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/deficiencies/:deficiency_id/photos(.:format)
 * @param {any} deficiencyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2DeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"deficiency_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"deficiency_id"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/devices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2DevicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/devices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2DevicesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2InspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/inspections/:inspection_id/attachments(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2InspectionAttachmentsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2InspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2InvoicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/invoices/reference/:reference(.:format)
 * @param {any} reference
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2InvoiceByReferencePath = /*#__PURE__*/ __jsr.r({"reference":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"reference"],[2,[7,"/"],[2,[3,"reference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2InvoicesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/long_form_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2LongFormTemplatesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"long_form_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2ReportsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/devices/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2SettingsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/subcontractors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2SubcontractorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/subcontractor/inspections/:inspection_id/documents(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2SubcontractorInspectionDocumentsPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/subcontractors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2SubcontractorsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subcontractors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v2/devices/types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalApiV2TypesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[6,"types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/external_forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalFormPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"external_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/external_form_pdf_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalFormPdfAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"external_form_pdf_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/external_forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalFormsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"external_forms"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/extinguisher_projection_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extinguisherProjectionReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"extinguisher_projection_report"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/extinguishers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extinguishersAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"extinguishers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/fetch_filtered_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetchFilteredIdsInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"fetch_filtered_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/fetch_filtered_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetchFilteredIdsWorkOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"fetch_filtered_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/visits/fetch_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetchVisitsApiV1VisitsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[6,"fetch_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/filter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filterBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/lookup/find_index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const findIndexApiTechnicianPortalLookupPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"find_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireAlarmAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_answers/:fire_alarm_answer_id/deficiency_photos/:id(.:format)
 * @param {any} fireAlarmAnswerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireAlarmAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_alarm_answer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[3,"fire_alarm_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_answers/:fire_alarm_answer_id/deficiency_photos(.:format)
 * @param {any} fireAlarmAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireAlarmAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_alarm_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[3,"fire_alarm_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireAlarmAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_system_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireAlarmSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_system_question_sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireAlarmSystemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_system_question_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_system_question_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireAlarmSystemQuestionSectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_system_question_sections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireAlarmSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_dampers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDamperPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_damper_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDamperAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_damper_answers/:fire_damper_answer_id/deficiency_photos/:id(.:format)
 * @param {any} fireDamperAnswerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDamperAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_damper_answer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[3,"fire_damper_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_damper_answers/:fire_damper_answer_id/deficiency_photos(.:format)
 * @param {any} fireDamperAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDamperAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_damper_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[3,"fire_damper_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_damper_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDamperAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_damper_answers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_dampers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDampersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_dampers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_answers/:fire_door_answer_id/deficiency_photos/:id(.:format)
 * @param {any} fireDoorAnswerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_answer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[3,"fire_door_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_answers/:fire_door_answer_id/deficiency_photos(.:format)
 * @param {any} fireDoorAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[3,"fire_door_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_answers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:fire_door_group_id/fire_doors/:id(.:format)
 * @param {any} fireDoorGroupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorGroupFireDoorPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"fire_door_group_id"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:fire_door_group_id/fire_doors(.:format)
 * @param {any} fireDoorGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorGroupFireDoorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"fire_door_group_id"],[2,[7,"/"],[2,[6,"fire_doors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:fire_door_group_id/fire_doors/listing(.:format)
 * @param {any} fireDoorGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorGroupFireDoorsListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"fire_door_group_id"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:fire_door_group_id/fire_doors/mass_update(.:format)
 * @param {any} fireDoorGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorGroupFireDoorsMassUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"fire_door_group_id"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:fire_door_group_id/fire_doors/reorder_listing(.:format)
 * @param {any} fireDoorGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorGroupFireDoorsReorderListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"fire_door_group_id"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[6,"reorder_listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorGroupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_system_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireDoorSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_answers/:fire_exit_sign_answer_id/deficiency_photos/:id(.:format)
 * @param {any} fireExitSignAnswerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_answer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[3,"fire_exit_sign_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_answers/:fire_exit_sign_answer_id/deficiency_photos(.:format)
 * @param {any} fireExitSignAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[3,"fire_exit_sign_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs/:id(.:format)
 * @param {any} fireExitSignGroupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupFireExitSignPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs/:fire_exit_sign_id/activate(.:format)
 * @param {any} fireExitSignGroupId
 * @param {any} fireExitSignId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupFireExitSignActivatePath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"fire_exit_sign_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[3,"fire_exit_sign_id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs/:fire_exit_sign_id/exit_sign(.:format)
 * @param {any} fireExitSignGroupId
 * @param {any} fireExitSignId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupFireExitSignExitSignPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"fire_exit_sign_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[3,"fire_exit_sign_id"],[2,[7,"/"],[2,[6,"exit_sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs(.:format)
 * @param {any} fireExitSignGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupFireExitSignsPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs/listing(.:format)
 * @param {any} fireExitSignGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupFireExitSignsListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs/mass_update(.:format)
 * @param {any} fireExitSignGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupFireExitSignsMassUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs/reorder_listing(.:format)
 * @param {any} fireExitSignGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupFireExitSignsReorderListingPathPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[6,"reorder_listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignGroupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_manufacturers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignManufacturerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_manufacturers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_manufacturers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignManufacturersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_manufacturers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_system_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/import(.:format)
 * @param {any} fireExitSignGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignsImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/import_csv(.:format)
 * @param {any} fireExitSignGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignsImportCsvPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/import_pma(.:format)
 * @param {any} fireExitSignGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExitSignsImportPmaPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"import_pma"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguishers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_answers/:fire_extinguisher_answer_id/deficiency_photos/:id(.:format)
 * @param {any} fireExtinguisherAnswerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_answer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[3,"fire_extinguisher_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_answers/:fire_extinguisher_answer_id/deficiency_photos(.:format)
 * @param {any} fireExtinguisherAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[3,"fire_extinguisher_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_deficiencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_deficiencies"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_deficiencies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_deficiencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/fire_extinguishers/:id(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherGroupFireExtinguisherPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/fire_extinguishers/:fire_extinguisher_id/activate(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {any} fireExtinguisherId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherGroupFireExtinguisherActivatePath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"fire_extinguisher_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[3,"fire_extinguisher_id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/fire_extinguishers(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherGroupFireExtinguishersPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/fire_extinguishers/listing(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherGroupFireExtinguishersListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/fire_extinguishers/mass_update(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherGroupFireExtinguishersMassUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/fire_extinguishers/reorder_listing(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherGroupFireExtinguishersReorderListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"reorder_listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherGroupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_makes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherMakePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_makes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_makes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherMakesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_makes"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_swap_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherSwapItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_swap_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_swap_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherSwapItemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_swap_items"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_system_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_weights/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherWeightPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_weights"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_weights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguisherWeightsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_weights"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguishers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguishersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguishers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/import(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguishersImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/import_csv(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguishersImportCsvPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/import_pma(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fireExtinguishersImportPmaPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"import_pma"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/integrations/fleet_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleetManagerExternalApiV1IntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"fleet_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/map/fleet_manager_sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleetManagerSsoMapPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"fleet_manager_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/integrations/fleet_manager/visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleetManagerVisitsExternalApiV1IntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"fleet_manager"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fleet_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleetTrackingPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fleet_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/map/fleet_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fleetTrackingMapPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"fleet_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/forgot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forgotPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"forgot"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/frontend_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frontendLogsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"frontend_logs"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/full_page_calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fullPageCalendarInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"full_page_calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/generate_answers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateAnswersInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices/generate_legends(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateLegendsAlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"generate_legends"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/alarm_devices/generate_legends(.:format)
 * @param {any} smokeCOId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateLegendsSmokeCOAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"generate_legends"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:id/generate_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateReportApiTechnicianPortalInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspections/generate_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateReportExternalApiV1InspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"generate_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/generate_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateReportsInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"generate_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/generic_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genericAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/generic_answers/:generic_answer_id/deficiency_photos/:id(.:format)
 * @param {any} genericAnswerId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genericAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"generic_answer_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[3,"generic_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/generic_answers/:generic_answer_id/deficiency_photos(.:format)
 * @param {any} genericAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genericAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"generic_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[3,"generic_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/generic_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genericAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"generic_answers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_questions/:id(.:format)
 * @param {any} objectType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genericQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_question_sections/:id(.:format)
 * @param {any} objectType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genericQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_question_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_question_sections(.:format)
 * @param {any} objectType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genericQuestionSectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_question_sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_questions(.:format)
 * @param {any} objectType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const genericQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_photos/get_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const getImagesApiV1WorkOrderPhotosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_photos"],[2,[7,"/"],[2,[6,"get_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_videos/get_work_order_videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const getWorkOrderVideosApiV1WorkOrderVideosPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_videos"],[2,[7,"/"],[2,[6,"get_work_order_videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/google_calendar_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const googleCalendarListPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"google_calendar_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const googleCallbackPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const googleRedirectPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/healthcheck(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheckIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"healthcheck"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/high_priority(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const highPriorityDashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"high_priority"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id/home_page_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const homePageUpdateAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"home_page_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/home_page_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const homePageUpdateBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"home_page_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_aero_back_flow_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importAeroBackFlowTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_aero_back_flow_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_aero_back_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importAeroBackFlowsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_aero_back_flows"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_catalogs/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importAlarmDeviceCatalogsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_alarm_devices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_alarm_system_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importAlarmSystemDetailsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_alarm_system_details"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_back_flow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importBackFlowPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_back_flow"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_back_flow_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importBackFlowDetailsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_back_flow_details"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_backend_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importBackendUsersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_backend_users"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_building"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_building_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importBuildingContactsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_building_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_building_site_identification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importBuildingSiteIdentificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_building_site_identification"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_capitol(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCapitolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_capitol"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_clean_agent_system(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCleanAgentSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_clean_agent_system"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_swap_items/import_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCsvFireExtinguisherSwapItemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_swap_items"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials/import_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCsvMaterialsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/import_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCsvProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_damper(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importDamperPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_damper"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_equipment_alarms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importEquipmentAlarmsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_equipment_alarms"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_equipment_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importEquipmentSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_equipment_systems"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_external_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importExternalFormPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_external_form"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_fire_alarm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFireAlarmPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_fire_alarm"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_fire_door(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFireDoorPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_fire_door"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_fire_exit_sign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFireExitSignPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_fire_exit_sign"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_fire_extinguisher(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFireExtinguisherPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_fire_extinguisher"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/import_from_qb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFromQbAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"import_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/import_from_qb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFromQbBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"import_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/import_from_qb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importFromQbProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[6,"import_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_inspection_series(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_inspection_series"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_itv_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importITVDetailsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_itv_details"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/import_qb_customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importQbCustomersAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"import_qb_customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/import_qb_customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importQbCustomersBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"import_qb_customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_sales_people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importSalesPeoplePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_sales_people"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_service_trade_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importServiceTradeJobsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_service_trade_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_special_alarm_devices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importSpecialAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_special_alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_special_hazard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importSpecialHazardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_special_hazard"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_special_hazard_cylinders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importSpecialHazardCylindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_special_hazard_cylinders"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_special_hazard_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importSpecialHazardDetailsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_special_hazard_details"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_states(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importStatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_states"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_technicians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_technicians"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_offs/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importTimeOffsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_offs"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/import_valve_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importValveDetailsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"import_valve_details"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/alarm_device_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAlarmDeviceAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"alarm_device_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/alarm_device_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAlarmDeviceAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"alarm_device_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/all_notes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAllNotesPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"all_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/attachments/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/attachments(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAttachmentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/audibility_test_readings/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAudibilityTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"audibility_test_readings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/audibility_test_readings(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionAudibilityTestReadingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"audibility_test_readings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/circuit_fault_tolerance_test_readings/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionCircuitFaultToleranceTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"circuit_fault_tolerance_test_readings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/circuit_fault_tolerance_test_readings(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionCircuitFaultToleranceTestReadingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"circuit_fault_tolerance_test_readings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/control_panel_readings/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionControlPanelReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"control_panel_readings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/control_panel_readings(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionControlPanelReadingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"control_panel_readings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/cylinder_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionCylinderAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"cylinder_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/cylinder_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionCylinderAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"cylinder_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/inspection_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionDashboardAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"inspection_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/dry_valve_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionDryValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"dry_valve_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/dry_valve_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionDryValveAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"dry_valve_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/equipment_inspection_infos/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionEquipmentInspectionInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipment_inspection_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/equipment_inspection_infos(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionEquipmentInspectionInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipment_inspection_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_alarm_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireAlarmAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_alarm_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireAlarmAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_damper_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireDamperAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_damper_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireDamperAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_damper_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_door_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireDoorAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_door_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireDoorAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_door_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_exit_sign_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireExitSignAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_exit_sign_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireExitSignAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_extinguisher_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireExtinguisherAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_extinguisher_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireExtinguisherAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_extinguisher_groups(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireExtinguisherGroupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_hose_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireHoseAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_hose_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_hose_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionFireHoseAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_hose_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/generic_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionGenericAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/generic_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionGenericAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"generic_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/hose_valve_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionHoseValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"hose_valve_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/hose_valve_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionHoseValveAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"hose_valve_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_asset_proposed_corrections/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectionAssetProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_asset_proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_asset_proposed_corrections(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectionAssetProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_asset_proposed_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_external_forms/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectionExternalFormPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_external_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_external_forms(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectionExternalFormsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_external_forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_proposed_corrections/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectionProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_proposed_corrections(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectionProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_proposed_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_system_proposed_corrections/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectionSystemProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_system_proposed_corrections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_system_proposed_corrections(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectionSystemProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_system_proposed_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspectors_test_valve_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectorsTestValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspectors_test_valve_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspectors_test_valve_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionInspectorsTestValveAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspectors_test_valve_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/non_life_safety_circuit_supervision_test_readings/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionNonLifeSafetyCircuitSupervisionTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"non_life_safety_circuit_supervision_test_readings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/non_life_safety_circuit_supervision_test_readings(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionNonLifeSafetyCircuitSupervisionTestReadingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"non_life_safety_circuit_supervision_test_readings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/proposal_inclusions/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionProposalInclusionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"proposal_inclusions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/proposal_inclusions(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionProposalInclusionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"proposal_inclusions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/proposal_line_items/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionProposalLineItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"proposal_line_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/proposal_line_items(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionProposalLineItemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"proposal_line_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/remarks/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionRemarkPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"remarks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/remarks(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionRemarksPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"remarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/inspection_send_extinguishers_to_fdny(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSendExtinguishersToFdnyInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"inspection_send_extinguishers_to_fdny"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_series/bulk_extend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSeriesBulkExtendPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[6,"bulk_extend"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_series/listing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSeriesListingPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_series/:id/move_series(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSeriesMoveSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_series"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_series/:id/toggle_auto_extend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSeriesToggleAutoExtendPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_auto_extend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/signatures/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSignaturePath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/signatures(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSignaturesPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection/statuses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection"],[2,[7,"/"],[2,[6,"statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_status_notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionStatusNotificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_status_notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_status_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionStatusNotificationsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_status_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection/statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionStatusesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection"],[2,[7,"/"],[2,[6,"statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/subsequent_alarm_control_panel_test_readings/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSubsequentAlarmControlPanelTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"subsequent_alarm_control_panel_test_readings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/subsequent_alarm_control_panel_test_readings(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSubsequentAlarmControlPanelTestReadingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"subsequent_alarm_control_panel_test_readings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/system_questions/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/system_questions(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionTemplatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_templates"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/ulc_ancillary_device_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionUlcAncillaryDeviceAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"ulc_ancillary_device_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/ulc_ancillary_device_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionUlcAncillaryDeviceAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"ulc_ancillary_device_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/valve_answers/:id(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"valve_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/valve_answers(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionValveAnswersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"valve_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionVisitPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionVisitsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_visits"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/choose_building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionsChooseBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"choose_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionsDashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/day_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionsDayViewPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"day_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/download_xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionsDownloadXmlPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"download_xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/update_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionsUpdateStatusesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"update_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/update_technicians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectionsUpdateTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"update_technicians"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/inspector_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectorStepIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"inspector_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/inspector_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inspectorStepTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"inspector_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal_check_valve_five_year_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalCheckValveFiveYearAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal_check_valve_five_year_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal_pipe_five_year_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPipeFiveYearAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal_pipe_five_year_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inventory_sources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inventorySourcePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inventory_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inventory_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inventorySourcesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inventory_sources"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/inventory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inventoryTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/:id/invitation_statuses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationStatusesContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invitation_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/:id/invite(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inviteContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:invoice_id/attachments/:id(.:format)
 * @param {any} invoiceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"invoice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:invoice_id/attachments(.:format)
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceAttachmentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"invoice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoice_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceCategoriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoice_categories"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoice_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceCategoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoice_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/invoice_email_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceEmailModalInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"invoice_email_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/invoice_insights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceInsightsAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"invoice_insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/invoice(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoice_reminders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceRemindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoice_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoice_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoiceSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoice_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoicesDashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const irolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/irol_inspectors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const irolInspectorsTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"irol_inspectors"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:account_id/buildings/link_building(.:format)
 * @param {any} accountId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBuildingAccountBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"account_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"link_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/accounts/:id/link_building(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBuildingExternalApiV1AccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/link_building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBuildingIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"link_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/link_building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkBuildingTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"link_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/link_tech(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkTechIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"link_tech"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/link_tech(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkTechTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"link_tech"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices/listing(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingAlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/lookup/listing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingApiTechnicianPortalLookupPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hoses/listing(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingAssetFireHosesPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hoses"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/hose_valves/listing(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingAssetHoseValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"hose_valves"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/cylinders/listing(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingCleanAgentSystemCylindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_swap_items/listing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingFireExtinguisherSwapItemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_swap_items"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/lookup/listing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingLookupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/lookup/listing_map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingMapLookupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"listing_map"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials/listing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingMaterialsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:monitoring_system_id/devices/listing(.:format)
 * @param {any} monitoringSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingMonitoringSystemDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"monitoring_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"monitoring_system_id"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/listing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingMonitoringSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/alarm_devices/listing(.:format)
 * @param {any} smokeCOId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingSmokeCOAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/alarm_devices/listing(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingSpecialHazardAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cylinders/listing(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingSpecialHazardCylindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/sprinkler_heads/listing(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listingSystemSprinklerHeadsPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loginPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/logos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logoPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"logos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/logos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logosPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"logos"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logoutPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/lookup/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookupAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/lookup/buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookupBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/lookup/proposed_corrections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookupProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"proposed_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/make_tokenized_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makeTokenizedPaymentPaymentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"make_tokenized_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/manage_workflow_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manageWorkflowStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"manage_workflow_status"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/lookup/map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapApiTechnicianPortalLookupPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/map(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/signatures/:id/map(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapInspectionSignaturePath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/lookup/map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapLookupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"lookup"],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/work_order_signatures/:id/map(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapWorkOrderWorkOrderSignaturePath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"work_order_signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/mark_as_due(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsDueInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_due"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/mark_as_paid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsPaidInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"mark_as_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/mark_as_published(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsPublishedInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"mark_as_published"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/mark_as_published(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsPublishedProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"mark_as_published"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/mark_as_voided(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markAsVoidedInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_voided"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/:id/mark_inactive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markInactiveTechnicianPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/building_notes/mass_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massCreateApiV1BuildingNotesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_notes"],[2,[7,"/"],[2,[6,"mass_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices/mass_edit(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditAlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hoses/mass_edit(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditAssetFireHosesPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hoses"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/hose_valves/mass_edit(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditAssetHoseValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"hose_valves"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/mass_edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditAssetsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_dampers/mass_edit(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditFireDampersPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_swap_items/mass_edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditFireExtinguisherSwapItemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_swap_items"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:monitoring_system_id/devices/mass_edit(.:format)
 * @param {any} monitoringSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditMonitoringSystemDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"monitoring_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"monitoring_system_id"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems_device_types/mass_edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditMonitoringSystemsDeviceTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems_device_types"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/alarm_devices/mass_edit(.:format)
 * @param {any} smokeCOId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditSmokeCOAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/alarm_devices/mass_edit(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditSpecialHazardAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/mass_edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massEditSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_dampers/mass_index(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massIndexFireDampersPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[6,"mass_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices/mass_update(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateAlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/remarks/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateApiV3RemarksPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"remarks"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hoses/mass_update(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateAssetFireHosesPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hoses"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/hose_valves/mass_update(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateAssetHoseValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"hose_valves"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateAssetsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/attachments/mass_update(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateBuildingBuildingAttachmentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/alarm_devices/mass_update(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateCleanAgentSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/cylinders/mass_update(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateCleanAgentSystemCylindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_dampers/mass_update(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateFireDampersPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateMaterialsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:monitoring_system_id/devices/mass_update(.:format)
 * @param {any} monitoringSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateMonitoringSystemDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"monitoring_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"monitoring_system_id"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems_device_types/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateMonitoringSystemsDeviceTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems_device_types"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/alarm_devices/mass_update(.:format)
 * @param {any} smokeCOId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateSmokeCOAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/alarm_devices/mass_update(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateSpecialHazardAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cylinders/mass_update(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateSpecialHazardCylindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/sprinkler_heads/mass_update(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateSystemSprinklerHeadsPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/mass_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massUpdateSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materialPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/material_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materialTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"material_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/material_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materialTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"material_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materialsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_used/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materialsUsedPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_used"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_used(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const materialsUsedIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_used"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/merge_suggested_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeSuggestedAccountsAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"merge_suggested_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_questions/modal_new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modalNewSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[6,"modal_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoringSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:monitoring_system_id/devices/:id(.:format)
 * @param {any} monitoringSystemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoringSystemDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"monitoring_system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"monitoring_system_id"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:monitoring_system_id/devices(.:format)
 * @param {any} monitoringSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoringSystemDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"monitoring_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"monitoring_system_id"],[2,[7,"/"],[2,[6,"devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoringSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems_device_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoringSystemsDeviceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems_device_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems_device_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoringSystemsDeviceTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems_device_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_types/move_alarm_device(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveAlarmDeviceAlarmDeviceTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_types"],[2,[7,"/"],[2,[6,"move_alarm_device"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_catalogs/move_alarm_device_catalog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moveAlarmDeviceCatalogAlarmDeviceCatalogsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[6,"move_alarm_device_catalog"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/import/mtu_xml(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mtuXmlAlarmSystemImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"mtu_xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/account_info/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"account_info"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_answer_deficiencies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmDeviceAnswerDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_answer_deficiencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_catalogs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmDeviceCatalogPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_device_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmDeviceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_device_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/alarm_devices/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/control_panels/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_system_deficiencies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_system_deficiencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/device_legends/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemDeviceLegendPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"device_legends"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_ancillary_devices/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemUlcAncillaryDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_ancillary_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_annunciators/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemUlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_control_panels/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemUlcControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_data_communication_links/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemUlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_power_supplies/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemUlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_printers/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemUlcPrinterPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_remote_trouble_signal_units/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemUlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/ulc_voice_communications/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlarmSystemUlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alternate_headers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAlternateHeaderPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alternate_headers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answer_choices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAnswerChoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answer_choices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answers/:answer_id/deficiency_photos/new(.:format)
 * @param {any} answerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api_keys/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiKeyPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalBuildingPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:building_id/inspections/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalBuildingInspectionPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/buildings/:building_id/visits/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalBuildingVisitPath = /*#__PURE__*/ __jsr.r({"building_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/contacts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalContactPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/deficiencies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalDeficiencyPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalDocumentPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/document_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalDocumentTypePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalInspectionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/invoices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalInvoicePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalMaterialsAndServicePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalMaterialsAndServicesTypePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/price_factors/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalPriceFactorPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"price_factors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalReportPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/technicians/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalTechnicianPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalWorkOrderPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/materials_and_services/new(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiTechnicianPortalWorkOrderMaterialsAndServicePath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"materials_and_services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_device_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmDeviceDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_device_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/alarm_devices/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_annunciators/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemUlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_control_panels/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemUlcControlPanelPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_data_communication_links/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemUlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_power_supplies/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemUlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_printers/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemUlcPrinterPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_remote_trouble_signal_units/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemUlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/alarm_systems/:alarm_system_id/ulc_voice_communications/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AlarmSystemUlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/answers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AnswerPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/assets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AssetPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/audibility_test_reading_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1AudibilityTestReadingDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"audibility_test_reading_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/back_flows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1BackFlowPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1BuildingPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/building_notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1BuildingNotePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clean_agent_systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1CleanAgentSystemPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/clean_agent_systems/:clean_agent_system_id/alarm_devices/new(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1CleanAgentSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"clean_agent_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/contacts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1ContactPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/control_panel_reading_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1ControlPanelReadingDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"control_panel_reading_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/custom_inspections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1CustomInspectionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cylinder_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1CylinderDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cylinder_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1DeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dry_valve_answer_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1DryValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dry_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/equipment_inspection_info_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1EquipmentInspectionInfoPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"equipment_inspection_info_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/external_forms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1ExternalFormPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"external_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_dampers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireDamperPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_damper_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireDamperDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_damper_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_doors/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireDoorPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_door_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireDoorDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_door_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireDoorGroupPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_signs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireExitSignPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_sign_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireExitSignDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_exit_sign_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_extinguishers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireExtinguisherPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_extinguisher_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fire_hose_answer_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FireHoseAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_hose_answer_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1FormPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/generic_answer_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1GenericAnswerPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"generic_answer_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/hose_valve_answer_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1HoseValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"hose_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectionAnswerPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_attachments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectionAttachmentPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_attachments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_custom_inspections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectionCustomInspectionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_custom_inspections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/deficiencies/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectionDeficiencyPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectionDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_external_forms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectionExternalFormPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_external_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspection_external_form_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectionExternalFormDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_external_form_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspectors_test_valve_answer_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InspectorsTestValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspectors_test_valve_answer_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/internal_check_valve_five_year_answer_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InternalCheckValveFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"internal_check_valve_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/internal_pipe_five_year_answer_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1InternalPipeFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"internal_pipe_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/materials/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1MaterialPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pressure_reducing_valve_five_year_answer_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1PressureReducingValveFiveYearAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pressure_reducing_valve_five_year_answer_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/proposals/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1ProposalPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/proposed_corrections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1ProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/special_hazards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1SpecialHazardPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sprinkler_heads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1SprinklerHeadPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1SystemPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_ancillary_device_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1UlcAncillaryDeviceDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_ancillary_device_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_annunciators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1UlcAnnunciatorPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_annunciators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_control_panels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1UlcControlPanelPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_control_panels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_data_communication_links/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1UlcDataCommunicationLinkPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_data_communication_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_power_supplies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1UlcPowerSupplyPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_power_supplies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_printers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1UlcPrinterPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_printers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_remote_trouble_signal_units/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1UlcRemoteTroubleSignalUnitPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_remote_trouble_signal_units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ulc_voice_communications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1UlcVoiceCommunicationPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ulc_voice_communications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/valve_answer_deficiency_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1ValveAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"valve_answer_deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/videos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1VideoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/visits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1VisitPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1WorkOrderPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_photos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1WorkOrderPhotoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_order_videos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV1WorkOrderVideoPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_order_videos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV2AlarmSystemPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/:alarm_system_id/alarm_devices/new(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV2AlarmSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/alarm_device_catalogs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV3AlarmDeviceCatalogPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"alarm_device_catalogs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/swap_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiV3SwapItemPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"swap_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/emergency_generator_infos/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetEmergencyGeneratorInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"emergency_generator_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hoses/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetFireHosePath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hoses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_hydrant_infos/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetFireHydrantInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_hydrant_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fire_pump_infos/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetFirePumpInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fire_pump_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/foam_water_infos/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetFoamWaterInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"foam_water_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/fuel_tank_infos/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetFuelTankInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"fuel_tank_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/hose_valves/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetHoseValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"hose_valves"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/kitchen_hood_infos/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetKitchenHoodInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"kitchen_hood_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/paint_spray_booth_infos/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetPaintSprayBoothInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"paint_spray_booth_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/assets/:asset_id/transfer_switch_infos/new(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAssetTransferSwitchInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"asset_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"transfer_switch_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/attachment_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAttachmentCategoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"attachment_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBackFlowPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_certifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBackFlowCertificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_certifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/back_flow_test_kits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBackFlowTestKitPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"back_flow_test_kits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/alarm_systems/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingAlarmSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/areas/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingAreaPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/assets/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingAssetPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/back_flows/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingBackFlowPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"back_flows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/attachments/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingBuildingAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_dry_valves/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingBuildingDryValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_dry_valves"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_notes/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingBuildingNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/building_reminders/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingBuildingReminderPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"building_reminders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/contacts/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/deficiencies/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/equipments/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingEquipmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_dampers/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingFireDamperPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_door_groups/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingFireDoorGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_exit_sign_groups/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingFireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/fire_extinguisher_groups/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingFireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_templates/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingInspectionTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspectors_test_valves/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingInspectorsTestValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/notes/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/reports/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/sales_people/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingSalesPersonPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"sales_people"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/smoke_cos/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingSmokeCOPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/systems/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/valves/new(.:format)
 * @param {any} buildingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBuildingValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCleanAgentSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/alarm_devices/new(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCleanAgentSystemAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/control_panels/new(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCleanAgentSystemControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_systems/:clean_agent_system_id/cylinders/new(.:format)
 * @param {any} cleanAgentSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCleanAgentSystemCylinderPath = /*#__PURE__*/ __jsr.r({"locale":{},"clean_agent_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_systems"],[2,[7,"/"],[2,[3,"clean_agent_system_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_system_questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCleanAgentSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clean_agent_system_question_sections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCleanAgentSystemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clean_agent_system_question_sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/code_years/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCodeYearPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"code_years"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/company_holidays/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCompanyHolidayPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"company_holidays"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/control_panel_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newControlPanelTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"control_panel_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/cost_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCostCodePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"cost_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_fields_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomFieldsTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_fields_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:custom_inspection_id/custom_inspection_sections/new(.:format)
 * @param {any} customInspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomInspectionCustomInspectionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"custom_inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"custom_inspection_id"],[2,[7,"/"],[2,[6,"custom_inspection_sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_inspections/:custom_inspection_id/questions/new(.:format)
 * @param {any} customInspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomInspectionQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"custom_inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_inspections"],[2,[7,"/"],[2,[3,"custom_inspection_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/custom_system_questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerRegistrationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCustomerSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/default_technician_notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDefaultTechnicianNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"default_technician_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiency_report_notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDeficiencyReportNotePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiency_report_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiency_resolution_statuses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDeficiencyResolutionStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiency_resolution_statuses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEquipmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_deficiencies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEquipmentDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_deficiencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment/:equipment_id/equipment_top_level_attributes/new(.:format)
 * @param {any} equipmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEquipmentEquipmentTopLevelAttributePath = /*#__PURE__*/ __jsr.r({"locale":{},"equipment_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment"],[2,[7,"/"],[2,[3,"equipment_id"],[2,[7,"/"],[2,[6,"equipment_top_level_attributes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_inspection_infos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEquipmentInspectionInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_inspection_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_statuses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEquipmentStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_statuses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/equipment_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEquipmentTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"equipment_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/exclusions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExclusionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"exclusions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1BuildingPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/building_tags/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1BuildingTagPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/contacts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1ContactPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1InspectionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspection_visits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1InspectionVisitPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspection_visits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/invoices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1InvoicePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/proposed_corrections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1ProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/teams/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1TeamPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/territories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1TerritoryPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"territories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/webhook_endpoints/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newExternalApiV1WebhookEndpointPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook_endpoints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_answers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireAlarmAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_answers/:fire_alarm_answer_id/deficiency_photos/new(.:format)
 * @param {any} fireAlarmAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireAlarmAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_alarm_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[3,"fire_alarm_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_system_questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireAlarmSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_system_question_sections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireAlarmSystemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_system_question_sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_dampers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireDamperPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_dampers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_damper_answers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireDamperAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_damper_answers/:fire_damper_answer_id/deficiency_photos/new(.:format)
 * @param {any} fireDamperAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireDamperAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_damper_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[3,"fire_damper_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_answers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireDoorAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_answers/:fire_door_answer_id/deficiency_photos/new(.:format)
 * @param {any} fireDoorAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireDoorAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[3,"fire_door_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireDoorGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_groups/:fire_door_group_id/fire_doors/new(.:format)
 * @param {any} fireDoorGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireDoorGroupFireDoorPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_groups"],[2,[7,"/"],[2,[3,"fire_door_group_id"],[2,[7,"/"],[2,[6,"fire_doors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_system_questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireDoorSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_answers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExitSignAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_answers/:fire_exit_sign_answer_id/deficiency_photos/new(.:format)
 * @param {any} fireExitSignAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExitSignAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[3,"fire_exit_sign_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExitSignGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_groups/:fire_exit_sign_group_id/fire_exit_signs/new(.:format)
 * @param {any} fireExitSignGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExitSignGroupFireExitSignPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_groups"],[2,[7,"/"],[2,[3,"fire_exit_sign_group_id"],[2,[7,"/"],[2,[6,"fire_exit_signs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_manufacturers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExitSignManufacturerPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_manufacturers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_system_questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExitSignSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExitSignTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguishers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_answers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_answers/:fire_extinguisher_answer_id/deficiency_photos/new(.:format)
 * @param {any} fireExtinguisherAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[3,"fire_extinguisher_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_deficiencies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_deficiencies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_groups/:fire_extinguisher_group_id/fire_extinguishers/new(.:format)
 * @param {any} fireExtinguisherGroupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherGroupFireExtinguisherPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_group_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_makes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherMakePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_makes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_swap_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherSwapItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_swap_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_system_questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_weights/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFireExtinguisherWeightPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_weights"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/generic_answers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGenericAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/generic_answers/:generic_answer_id/deficiency_photos/new(.:format)
 * @param {any} genericAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGenericAnswerDeficiencyPhotoPath = /*#__PURE__*/ __jsr.r({"locale":{},"generic_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[3,"generic_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_questions/new(.:format)
 * @param {any} objectType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGenericQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_question_sections/new(.:format)
 * @param {any} objectType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGenericQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_question_sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/alarm_device_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionAlarmDeviceAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"alarm_device_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/attachments/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/audibility_test_readings/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionAudibilityTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"audibility_test_readings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/circuit_fault_tolerance_test_readings/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionCircuitFaultToleranceTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"circuit_fault_tolerance_test_readings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/control_panel_readings/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionControlPanelReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"control_panel_readings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/cylinder_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionCylinderAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"cylinder_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/dry_valve_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionDryValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"dry_valve_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/equipment_inspection_infos/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionEquipmentInspectionInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipment_inspection_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_alarm_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionFireAlarmAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_damper_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionFireDamperAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_door_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionFireDoorAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_exit_sign_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionFireExitSignAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_extinguisher_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionFireExtinguisherAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/fire_hose_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionFireHoseAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"fire_hose_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/generic_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionGenericAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/hose_valve_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionHoseValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"hose_valve_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_asset_proposed_corrections/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionInspectionAssetProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_asset_proposed_corrections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_proposed_corrections/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionInspectionProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_proposed_corrections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspection_system_proposed_corrections/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionInspectionSystemProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspection_system_proposed_corrections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/inspectors_test_valve_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionInspectorsTestValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"inspectors_test_valve_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/non_life_safety_circuit_supervision_test_readings/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionNonLifeSafetyCircuitSupervisionTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"non_life_safety_circuit_supervision_test_readings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/proposal_inclusions/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionProposalInclusionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"proposal_inclusions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/proposal_line_items/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionProposalLineItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"proposal_line_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/remarks/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionRemarkPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"remarks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/signatures/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionSignaturePath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection/statuses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection"],[2,[7,"/"],[2,[6,"statuses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_status_notifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionStatusNotificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_status_notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/subsequent_alarm_control_panel_test_readings/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionSubsequentAlarmControlPanelTestReadingPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"subsequent_alarm_control_panel_test_readings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/system_questions/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/ulc_ancillary_device_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionUlcAncillaryDeviceAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"ulc_ancillary_device_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:inspection_id/valve_answers/new(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInspectionValveAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"valve_answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inventory_sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInventorySourcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inventory_sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:invoice_id/attachments/new(.:format)
 * @param {any} invoiceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInvoiceAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"invoice_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoice_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInvoiceCategoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoice_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/logos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLogoPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"logos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/map/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMapPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMaterialPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/material_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMaterialTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"material_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_used/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMaterialsUsedPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_used"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMonitoringSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems/:monitoring_system_id/devices/new(.:format)
 * @param {any} monitoringSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMonitoringSystemDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"monitoring_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems"],[2,[7,"/"],[2,[3,"monitoring_system_id"],[2,[7,"/"],[2,[6,"devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/monitoring_systems_device_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newMonitoringSystemsDeviceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"monitoring_systems_device_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPaymentPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payment_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPaymentSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payment_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payment_terms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPaymentTermPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payment_terms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/payment_methods/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPaymentsPaymentMethodPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPriceListPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_rules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPriceRulePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_factors/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProposalFactorPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_factors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_statuses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProposalStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_statuses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProposalTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal/templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProposalsTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProposedCorrectionTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:id/new_public_upload_url(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPublicUploadUrlApiTechnicianPortalInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_public_upload_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/new_public_upload_url(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPublicUploadUrlInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_public_upload_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newQbdSettingPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sandbox/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSandboxPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sandbox"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/scope_of_works/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newScopeOfWorkPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"scope_of_works"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceTradePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newServiceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/alarm_devices/new(.:format)
 * @param {any} smokeCOId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSmokeCOAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/aerosol_hazard_infos/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardAerosolHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"aerosol_hazard_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/alarm_devices/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cartridges/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardCartridgePath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cartridges"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/clean_agent_hazard_infos/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardCleanAgentHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"clean_agent_hazard_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/co2_hazard_infos/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardCO2HazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"co2_hazard_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/control_panels/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cylinders/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardCylinderPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/halon_hazard_infos/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardHalonHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"halon_hazard_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazard_system_questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazard_system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/vehicle_suppression_hazard_infos/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardVehicleSuppressionHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"vehicle_suppression_hazard_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_hazard_infos/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardWaterMistHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_hazard_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_pumps/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardWaterMistPumpsPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_pumps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_valves/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardWaterMistValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_valves"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/zones/new(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSpecialHazardZonesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractors/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSubcontractorPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/summaries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSummaryPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"summaries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/dry_valves/new(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSystemDryValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"dry_valves"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/inspectors_test_valves/new(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSystemInspectorsTestValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_question_sections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSystemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_question_sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/sprinkler_heads/new(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSystemSprinklerHeadPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/valves/new(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSystemValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tag_colors/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTagColorPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tag_colors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tax_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tax_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/teams/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTeamPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTechnicianPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technician_day_offs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTechnicianDayOffPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technician_day_offs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTechnicianPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTechnicianSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/terms_and_conditions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTermsAndConditionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"terms_and_conditions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/territories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTerritoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"territories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTimeEntryPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entry_rates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTimeEntryRatePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entry_rates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/top_level_attributes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTopLevelAttributePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"top_level_attributes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserRegistrationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newVisitPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visit_statuses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newVisitStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visit_statuses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_corrections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_corrections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_default_followups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderDefaultFollowupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_default_followups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_line_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderLineItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_line_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_statuses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_statuses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_summary_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderSummaryItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_summary_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/work_order_signatures/new(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrderWorkOrderSignaturePath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"work_order_signatures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/attachments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWorkOrdersAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/notification_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/quick_books_session/oauth_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthCallbackQuickBooksSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"quick_books_session"],[2,[7,"/"],[2,[6,"oauth_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/simpro/oauth_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthCallbackSimproPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"simpro"],[2,[7,"/"],[2,[6,"oauth_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/simpro/oauth_gateway(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthGatewaySimproPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"simpro"],[2,[7,"/"],[2,[6,"oauth_gateway"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/one_click_submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oneClickSubmitIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"one_click_submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/one_click_submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oneClickSubmitTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"one_click_submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/open_contract_expiry/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openContractExpiryNotificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"open_contract_expiry"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/open_due_battery_service/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openDueBatteryServiceNotificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"open_due_battery_service"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/open_inspection_series/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openInspectionSeriesNotificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"open_inspection_series"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/open_overdue_fire_extinguishers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openOverdueFireExtinguishersNotificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"open_overdue_fire_extinguishers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/open_proposal/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openProposalNotificationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"open_proposal"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/overdue_inspection_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overdueInspectionReportInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"overdue_inspection_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/overdue_inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overdueInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"overdue_inspections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/override_premise(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overridePremiseIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"override_premise"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/override_premise(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overridePremiseTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"override_premise"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/materials_and_services/:id/pagination_index(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paginationIndexApiTechnicianPortalMaterialsAndServicePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"materials_and_services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pagination_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/price_factors/:id/pagination_index(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paginationIndexApiTechnicianPortalPriceFactorPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"price_factors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pagination_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/parent_tax_rate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parentTaxRateBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"parent_tax_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/pay_now(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payNowPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"pay_now"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/pay_now_success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payNowSuccessInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"pay_now_success"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payment_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payment_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payment_terms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentTermPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payment_terms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payment_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentTermsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payment_terms"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsDashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/helpers/determine_billing_cost(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsHelpersDetermineBillingCostPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"helpers"],[2,[7,"/"],[2,[6,"determine_billing_cost"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/payments_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsHistoryAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"payments_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/payments_history_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsHistoryCsvAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"payments_history_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/modals/charge_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsModalsChargeV2Path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"modals"],[2,[7,"/"],[2,[6,"charge_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/modals/payment_type_select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsModalsPaymentTypeSelectPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"modals"],[2,[7,"/"],[2,[6,"payment_type_select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/modals/rename_payment_method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsModalsRenamePaymentMethodPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"modals"],[2,[7,"/"],[2,[6,"rename_payment_method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/payment_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsPaymentMethodPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/payment_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paymentsPaymentMethodsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"payment_methods"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/payrix_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payrixConfigInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"payrix_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/payrix_success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payrixSuccessInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"payrix_success"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/photos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const photoPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const photosPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/planned_inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plannedInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"planned_inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/forgot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portalForgotPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"forgot"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portalLoginPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portalLogoutPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/portal/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portalSignupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"portal"],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/premises(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const premisesIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"premises"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/premises(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const premisesTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"premises"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/pressure_reducing_valve_five_year_answers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pressureReducingValveFiveYearAnswerPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"pressure_reducing_valve_five_year_answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const priceListPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const priceListsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_lists"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const priceRulePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const priceRulesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_rules"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profilePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_attachments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalAttachmentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/proposal_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalDashboardAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"proposal_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_factors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalFactorPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_factors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/price_factors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalFactorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"price_factors"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_photos"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_reminders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalRemindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_reports"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_statuses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalStatusesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/proposal_user_details_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalUserDetailsReportAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"proposal_user_details_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/proposals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalsDashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"proposals"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal/templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalsTemplatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposal/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposalsTemplatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposal"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposedCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposedCorrectionTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposedCorrectionTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposed_correction_types/proposed_corrections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposedCorrectionTypesProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposed_correction_types"],[2,[7,"/"],[2,[6,"proposed_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposed_correction_types/proposed_corrections/price_levels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposedCorrectionTypesProposedCorrectionsPriceLevelsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposed_correction_types"],[2,[7,"/"],[2,[6,"proposed_corrections"],[2,[7,"/"],[2,[6,"price_levels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/public_passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicPasswordsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"public_passwords"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/public_upload_url(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicUploadUrlInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"public_upload_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/reports/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publishApiTechnicianPortalReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/push_to_irol(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pushToIrolInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"push_to_irol"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/push_to_tce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pushToTceInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"push_to_tce"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qbdSettingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qbdSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/settings/qbo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qboPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"qbo"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/qbo_customer_update_account(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qboCustomerUpdateAccountInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"qbo_customer_update_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/qbo_customer_update_building(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qboCustomerUpdateBuildingInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"qbo_customer_update_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const questionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const questionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/questions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const questionsInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/quick_books_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quickBooksSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"quick_books_session"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/v2/time_entries/rate_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rateTypesApiV2TimeEntriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"rate_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/react_example(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactExamplePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"react_example"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactivateBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/read_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const readNotificationsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"read_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/record_payment_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordPaymentModalPaymentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"record_payment_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/record_payrix_record(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordPayrixRecordPaymentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"record_payrix_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/mobile/v1/alarm_systems/:alarm_system_id/alarm_devices/records
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordsApiMobileV1AlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[6,"records"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/refresh_qbd_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshQbdAccountsQbdSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[6,"refresh_qbd_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/refresh_qbd_customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshQbdCustomersAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"refresh_qbd_customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/refresh_qbd_customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshQbdCustomersBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"refresh_qbd_customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/refresh_qbd_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshQbdItemsProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[6,"refresh_qbd_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/refresh_qbd_tax_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshQbdTaxRatesQbdSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[6,"refresh_qbd_tax_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshTokenIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshTokenTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/regenerate_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regeneratePasswordQbdSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[6,"regenerate_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectSubcontractorInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/work_orders/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectSubcontractorWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/remove_answers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeAnswersInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/remove_contact/:contact_id(.:format)
 * @param {any} id
 * @param {any} contactId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeContactBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"contact_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_contact"],[2,[7,"/"],[2,[3,"contact_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/remove_sales_person/:user_id(.:format)
 * @param {any} id
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeSalesPersonBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_sales_person"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/render_associate_to_building_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renderAssociateToBuildingModalPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"render_associate_to_building_modal"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/render_confirm_delete_modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renderConfirmDeleteModalPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"render_confirm_delete_modal"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/render_qb_customer_lookup_modal_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renderQbCustomerLookupModalV2Path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"render_qb_customer_lookup_modal_v2"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/report_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"report_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/report_submission_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportSubmissionStepIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"report_submission_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/report_submission_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportSubmissionStepTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"report_submission_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/report_template_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportTemplateStepIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"report_template_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/report_template_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportTemplateStepTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"report_template_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/delete_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsDeleteReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"delete_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/reports/mark_reports_public(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMarkReportsPublicPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"mark_reports_public"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/mobile/v1/alarm_systems/:alarm_system_id/alarm_devices/reposition
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repositionApiMobileV1AlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[6,"reposition"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/alarm_systems/:alarm_system_id/alarm_devices/reposition(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repositionApiV2AlarmSystemAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"alarm_system_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[6,"reposition"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/requeue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requeueQbdSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[6,"requeue"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inventory_sources/require_inventory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requireInventoryInventorySourcesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inventory_sources"],[2,[7,"/"],[2,[6,"require_inventory"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/invites/:id/resend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendSubcontractorInvitePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/reset_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetEmailIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"reset_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/reset_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetEmailTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"reset_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tenants/reset_google_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetGoogleTokenPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[6,"reset_google_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/deficiencies/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveApiTechnicianPortalDeficiencyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/resolve_conflicts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveConflictsInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve_conflicts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/resolve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:work_order_id/materials_and_services/:id/resync(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resyncApiTechnicianPortalWorkOrderMaterialsAndServicePath = /*#__PURE__*/ __jsr.r({"work_order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"materials_and_services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/retrieve_from_qb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieveFromQbAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"retrieve_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/retrieve_from_qb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieveFromQbBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"retrieve_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/retrieve_from_qb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieveFromQbProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[6,"retrieve_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/revenue_forecast(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revenueForecastPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"revenue_forecast"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /(:locale)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sandbox/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sandboxPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sandbox"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sandbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sandboxIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sandbox"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/qbd_settings/save(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saveQbdSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"qbd_settings"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/schedule_and_dispatch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduleAndDispatchInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"schedule_and_dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/scope_of_works/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scopeOfWorkPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"scope_of_works"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/scope_of_works(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scopeOfWorksPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"scope_of_works"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buildings/search_buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchBuildingsApiV1BuildingsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"search_buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/invites/:token/select_existing_company(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectExistingCompanySubcontractorInvitePath = /*#__PURE__*/ __jsr.r({"locale":{},"token":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"select_existing_company"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/payments/send_agreement_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendAgreementFormPaymentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"send_agreement_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/reports/:id/send_emails(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendEmailsApiTechnicianPortalReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:id/send_for_review(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendForReviewSubcontractorInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_for_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/work_orders/:id/send_for_review(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendForReviewSubcontractorWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_for_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/send_invite(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendInviteUserPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/send_invoice_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendInvoiceEmailInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"send_invoice_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/:id/send_proposal_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendProposalEmailProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_proposal_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/send_to_qbd(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToQbdBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_qbd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/send_to_qbd(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToQbdInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_qbd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id/send_to_qbo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToQBOAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_qbo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/send_to_qbo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToQBOBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_qbo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/send_to_qbo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendToQBOInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_qbo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/send_wo_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendWoEmailWorkOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"send_wo_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeAssetsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeConfigurationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/fetch_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeFetchLocationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"fetch_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeLocationsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/pull_job(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradePullJobPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"pull_job"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/pull_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradePullJobsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"pull_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/raw_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeRawLocationsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"raw_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/service_trade_webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeServiceTradeWebhookPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"service_trade_webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/service_trade_webhook_test(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeServiceTradeWebhookTestPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"service_trade_webhook_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_trade/update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTradeUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_trade"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/service_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const serviceTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"service_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/set_entity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setEntityIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"set_entity"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/accounts/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsExternalApiV1AccountsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/buildings/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsExternalApiV1BuildingsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/contacts/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsExternalApiV1ContactsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/fire_extinguishers/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsExternalApiV1FireExtinguishersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inspections/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsExternalApiV1InspectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/invoices/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsExternalApiV1InvoicesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/proposals/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsExternalApiV1ProposalsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/proposed_corrections/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsExternalApiV1ProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"proposed_corrections"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/:id/show_account_roles(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showAccountRolesContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_account_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/show_contact_roles(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showContactRolesBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_contact_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/show_deficiency_notes/:deficiency_id(.:format)
 * @param {any} deficiencyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showDeficiencyNotesPath = /*#__PURE__*/ __jsr.r({"locale":{},"deficiency_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"show_deficiency_notes"],[2,[7,"/"],[2,[3,"deficiency_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/show_deficiency_photos/:deficiency_id(.:format)
 * @param {any} deficiencyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"deficiency_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"show_deficiency_photos"],[2,[7,"/"],[2,[3,"deficiency_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/:id/show_territory_access_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showTerritoryAccessModalTechnicianPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_territory_access_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id/show_territory_access_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showTerritoryAccessModalUserPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_territory_access_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/show_wo_numbers/:proposal_id(.:format)
 * @param {any} proposalId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showWoNumbersPath = /*#__PURE__*/ __jsr.r({"locale":{},"proposal_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"show_wo_numbers"],[2,[7,"/"],[2,[3,"proposal_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signupPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/simple_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simpleUpdateInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"simple_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/simpro(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simproPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"simpro"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/integrations/simpro(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simproExternalApiV1IntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"simpro"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smokeCOPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/alarm_devices/:id(.:format)
 * @param {any} smokeCOId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smokeCOAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/alarm_devices(.:format)
 * @param {any} smokeCOId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smokeCOAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/import/smoke_co_csv(.:format)
 * @param {any} smokeCOId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smokeCOCsvSmokeCOImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"smoke_co_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/smoke_cos/:smoke_co_id/import(.:format)
 * @param {any} smokeCOId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smokeCOImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"smoke_co_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"smoke_cos"],[2,[7,"/"],[2,[3,"smoke_co_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/answers/:answer_id/deficiency_photos/sort(.:format)
 * @param {any} answerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/:deficiency_id/deficiency_photos/sort(.:format)
 * @param {any} deficiencyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortDeficiencyDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"deficiency_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"deficiency_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_alarm_answers/:fire_alarm_answer_id/deficiency_photos/sort(.:format)
 * @param {any} fireAlarmAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortFireAlarmAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_alarm_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_alarm_answers"],[2,[7,"/"],[2,[3,"fire_alarm_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_damper_answers/:fire_damper_answer_id/deficiency_photos/sort(.:format)
 * @param {any} fireDamperAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortFireDamperAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_damper_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_damper_answers"],[2,[7,"/"],[2,[3,"fire_damper_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_door_answers/:fire_door_answer_id/deficiency_photos/sort(.:format)
 * @param {any} fireDoorAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortFireDoorAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_door_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_door_answers"],[2,[7,"/"],[2,[3,"fire_door_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_exit_sign_answers/:fire_exit_sign_answer_id/deficiency_photos/sort(.:format)
 * @param {any} fireExitSignAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortFireExitSignAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_exit_sign_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_exit_sign_answers"],[2,[7,"/"],[2,[3,"fire_exit_sign_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_answers/:fire_extinguisher_answer_id/deficiency_photos/sort(.:format)
 * @param {any} fireExtinguisherAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortFireExtinguisherAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"fire_extinguisher_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_answers"],[2,[7,"/"],[2,[3,"fire_extinguisher_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/generic_answers/:generic_answer_id/deficiency_photos/sort(.:format)
 * @param {any} genericAnswerId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortGenericAnswerDeficiencyPhotosPath = /*#__PURE__*/ __jsr.r({"locale":{},"generic_answer_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"generic_answers"],[2,[7,"/"],[2,[3,"generic_answer_id"],[2,[7,"/"],[2,[6,"deficiency_photos"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sortable/reorder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sortableReorderPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sortable"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/inventory_sources/source(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sourceExternalApiV1InventorySourcesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inventory_sources"],[2,[7,"/"],[2,[6,"source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/aerosol_hazard_infos/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardAerosolHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"aerosol_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/aerosol_hazard_infos(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardAerosolHazardInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"aerosol_hazard_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/alarm_devices/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardAlarmDevicePath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/alarm_devices(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cartridges/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardCartridgePath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cartridges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cartridges(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardCartridgesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cartridges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/clean_agent_hazard_infos/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardCleanAgentHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"clean_agent_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/clean_agent_hazard_infos(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardCleanAgentHazardInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"clean_agent_hazard_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/co2_hazard_infos/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardCO2HazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"co2_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/co2_hazard_infos(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardCO2HazardInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"co2_hazard_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/control_panels/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardControlPanelPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"control_panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/control_panels(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardControlPanelsPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"control_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cylinders/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardCylinderPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cylinders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/cylinders(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardCylindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"cylinders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/halon_hazard_infos/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardHalonHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"halon_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/halon_hazard_infos(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardHalonHazardInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"halon_hazard_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazard_system_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardSystemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazard_system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazard_system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazard_system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/vehicle_suppression_hazard_infos/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardVehicleSuppressionHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"vehicle_suppression_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/vehicle_suppression_hazard_infos(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardVehicleSuppressionHazardInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"vehicle_suppression_hazard_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_hazard_infos/:id(.:format)
 * @param {any} specialHazardId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardWaterMistHazardInfoPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_hazard_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_hazard_infos(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardWaterMistHazardInfosPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_hazard_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_pumps(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardWaterMistPumpsPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_pumps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/water_mist_valves(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardWaterMistValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"water_mist_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards/:special_hazard_id/zones(.:format)
 * @param {any} specialHazardId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardZonesPath = /*#__PURE__*/ __jsr.r({"locale":{},"special_hazard_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[2,[7,"/"],[2,[3,"special_hazard_id"],[2,[7,"/"],[2,[6,"zones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/special_hazards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specialHazardsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"special_hazards"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sprinkler_heads/export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprinklerHeadsExportCsvPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/import/srt(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const srtAlarmSystemImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"srt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:id/start(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startApiTechnicianPortalInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/document_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorDocumentTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/edit_documentation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorDocumentTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"edit_documentation"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/documentation/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorDocumentationPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"documentation"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/documentation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorDocumentationIndexPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"documentation"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipment(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/alarm_systems/:public_id(.:format)
 * @param {any} inspectionId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAlarmSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/alarm_systems/:alarm_system_public_id/alarm_device_types/:alarm_device_type_public_id/alarm_devices(.:format)
 * @param {any} inspectionId
 * @param {any} alarmSystemPublicId
 * @param {any} alarmDeviceTypePublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAlarmSystemAlarmDeviceTypeAlarmDevicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"alarm_system_public_id":{"r":true},"alarm_device_type_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_public_id"],[2,[7,"/"],[2,[6,"alarm_device_types"],[2,[7,"/"],[2,[3,"alarm_device_type_public_id"],[2,[7,"/"],[2,[6,"alarm_devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/alarm_systems/:alarm_system_public_id/alarm_device_types(.:format)
 * @param {any} inspectionId
 * @param {any} alarmSystemPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAlarmSystemAlarmDeviceTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"alarm_system_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_public_id"],[2,[7,"/"],[2,[6,"alarm_device_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/alarm_systems/:alarm_system_public_id/control_panels(.:format)
 * @param {any} inspectionId
 * @param {any} alarmSystemPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAlarmSystemControlPanelsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"alarm_system_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_public_id"],[2,[7,"/"],[2,[6,"control_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/alarm_systems(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAlarmSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"alarm_systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/assets/:public_id(.:format)
 * @param {any} inspectionId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAssetPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/assets/:asset_public_id/fire_hoses(.:format)
 * @param {any} inspectionId
 * @param {any} assetPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAssetFireHosesPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"asset_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_public_id"],[2,[7,"/"],[2,[6,"fire_hoses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/assets/:asset_public_id/hose_valves(.:format)
 * @param {any} inspectionId
 * @param {any} assetPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAssetHoseValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"asset_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_public_id"],[2,[7,"/"],[2,[6,"hose_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/assets(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsAssetsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/fire_extinguisher_groups/:public_id(.:format)
 * @param {any} inspectionId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsFireExtinguisherGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/fire_extinguisher_groups/:fire_extinguisher_group_public_id/fire_extinguishers(.:format)
 * @param {any} inspectionId
 * @param {any} fireExtinguisherGroupPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsFireExtinguisherGroupFireExtinguishersPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"fire_extinguisher_group_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[2,[7,"/"],[2,[3,"fire_extinguisher_group_public_id"],[2,[7,"/"],[2,[6,"fire_extinguishers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/fire_extinguisher_groups(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsFireExtinguisherGroupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"fire_extinguisher_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/overview(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsOverviewPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/systems/:public_id(.:format)
 * @param {any} inspectionId
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsSystemPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/systems/:system_public_id/dry_valves(.:format)
 * @param {any} inspectionId
 * @param {any} systemPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsSystemDryValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"system_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_public_id"],[2,[7,"/"],[2,[6,"dry_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/systems/:system_public_id/inspectors_test_valves(.:format)
 * @param {any} inspectionId
 * @param {any} systemPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsSystemInspectorsTestValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"system_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_public_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/systems/:system_public_id/valves(.:format)
 * @param {any} inspectionId
 * @param {any} systemPublicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsSystemValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"system_public_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_public_id"],[2,[7,"/"],[2,[6,"valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/inspections/:inspection_id/equipments/systems(.:format)
 * @param {any} inspectionId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorInspectionEquipmentsSystemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"inspection_id":{"r":true},"format":{"d":"json"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/parent_buildings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorParentBuildingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"parent_buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/parent_companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorParentCompaniesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"parent_companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcontractorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractors"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/submit_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitReportIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"submit_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/submit_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitReportTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"submit_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/inspections/:id/submit_to_prime(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitToPrimeApiTechnicianPortalInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_to_prime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/public/inspections/:id/submit_to_prime(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitToPrimeApiTechnicianPortalPublicInspectionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_to_prime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/work_orders/:id/submit_to_prime(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitToPrimeApiTechnicianPortalWorkOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_to_prime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/suggested_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggestedAccountsAccountsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"suggested_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summariesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"summaries"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/summaries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summaryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"summaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/swap_items/swap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const swapApiV3SwapItemsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"swap_items"],[2,[7,"/"],[2,[6,"swap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials_services/sync_existing_from_qb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncExistingFromQbProposedCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials_services"],[2,[7,"/"],[2,[6,"sync_existing_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/sync_future_inspections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncFutureInspectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"sync_future_inspections"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/sync_google_calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncGoogleCalendarPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[6,"sync_google_calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/quick_books_session/sync_tax_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncTaxRatesQuickBooksSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"quick_books_session"],[2,[7,"/"],[2,[6,"sync_tax_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/:id/sync_with_answer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncWithAnswerDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_with_answer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/sync_with_service_trade(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const syncWithServiceTradeBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_with_service_trade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/dry_valves/:id(.:format)
 * @param {any} systemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemDryValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"dry_valves"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/dry_valves(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemDryValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"dry_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/inspectors_test_valves/:id(.:format)
 * @param {any} systemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemInspectorsTestValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/inspectors_test_valves(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemInspectorsTestValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"inspectors_test_valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemQuestionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_question_sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemQuestionSectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_question_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_question_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemQuestionSectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_question_sections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_questions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/sprinkler_heads/:id(.:format)
 * @param {any} systemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemSprinklerHeadPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/sprinkler_heads(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemSprinklerHeadsPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"sprinkler_heads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/valves/:id(.:format)
 * @param {any} systemId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemValvePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/valves(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemValvesPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"valves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/valves/mass_edit(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemValvesMassEditPath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[6,"mass_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems/:system_id/valves/mass_update(.:format)
 * @param {any} systemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemValvesMassUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[3,"system_id"],[2,[7,"/"],[2,[6,"valves"],[2,[7,"/"],[2,[6,"mass_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/systems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"systems"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tag_colors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tagColorPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tag_colors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tag_colors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tagColorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tag_colors"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tax_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxGroupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tax_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tax_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tax_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tax_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxItemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tax_items"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tax_rates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxRatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /external/api/v1/integrations/tce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tceExternalApiV1IntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"external"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"tce"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/tce_inspectors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tceInspectorsTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"tce_inspectors"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/teams/:team_id/team_subcontractors/:id(.:format)
 * @param {any} teamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamTeamSubcontractorPath = /*#__PURE__*/ __jsr.r({"locale":{},"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"team_subcontractors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/teams/:team_id/team_subcontractors(.:format)
 * @param {any} teamId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamTeamSubcontractorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"team_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"team_subcontractors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/teams/:team_id/team_technicians/:id(.:format)
 * @param {any} teamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamTeamTechnicianPath = /*#__PURE__*/ __jsr.r({"locale":{},"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"team_technicians"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/teams/:team_id/team_technicians(.:format)
 * @param {any} teamId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamTeamTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"team_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"team_technicians"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teamsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/technician_complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianCompleteAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"technician_complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technician_day_offs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianDayOffPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technician_day_offs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technician_day_offs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianDayOffsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technician_day_offs"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/analytic_reports/technician_inspection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianInspectionAnalyticReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"analytic_reports"],[2,[7,"/"],[2,[6,"technician_inspection"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/:technician_id/team_technicians/:id(.:format)
 * @param {any} technicianId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianTeamTechnicianPath = /*#__PURE__*/ __jsr.r({"locale":{},"technician_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"technician_id"],[2,[7,"/"],[2,[6,"team_technicians"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/:technician_id/team_technicians(.:format)
 * @param {any} technicianId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technicianTeamTechniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"technician_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[3,"technician_id"],[2,[7,"/"],[2,[6,"team_technicians"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const techniciansPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/map/technicians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const techniciansMapPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"technicians"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/permitted_territories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const techniciansPermittedTerritoriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"permitted_territories"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technicians/permitted_territories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const techniciansPermittedTerritoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technicians"],[2,[7,"/"],[2,[6,"permitted_territories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/terms_and_conditions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsAndConditionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"terms_and_conditions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/terms_and_conditions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsAndConditionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"terms_and_conditions"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/territories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const territoriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"territories"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/territories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const territoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"territories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/test_kit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testKitTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"test_kit"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/testv1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testv1Path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"testv1"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeEntriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/v2/time_entries/time_entries_between_dates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeEntriesBetweenDatesApiV2TimeEntriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"time_entries_between_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/time_entries/time_entries_on_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeEntriesOnDateApiV2TimeEntriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"time_entries_on_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeEntryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entry_rates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeEntryRatePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entry_rates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/time_entry_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeEntryRatesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"time_entry_rates"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id/timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timelineAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timelineBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/:id/timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timelineContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timelineInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/:id/timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timelineInvoicePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/:id/timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timelineProposalPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:id/timeline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timelineWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/subcontractor/document_types/:id/toggle_active(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleActiveSubcontractorDocumentTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"subcontractor"],[2,[7,"/"],[2,[6,"document_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:id/toggle_publishing_to_customer_portal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const togglePublishingToCustomerPortalWorkOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_publishing_to_customer_portal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/top_level_attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topLevelAttributePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"top_level_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/top_level_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topLevelAttributesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"top_level_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/materials/transfer_to_corrections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transferToCorrectionsMaterialsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"materials"],[2,[7,"/"],[2,[6,"transfer_to_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/unlink_building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkBuildingIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"unlink_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/unlink_building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkBuildingTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"unlink_building"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/accounts/:id/unlink_from_qb(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkFromQbAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/unlink_from_qb(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkFromQbBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_from_qb"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/inspections/:inspection_id/deficiencies/:id/unlink_inspection(.:format)
 * @param {any} inspectionId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkInspectionApiV1InspectionDeficiencyPath = /*#__PURE__*/ __jsr.r({"inspection_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"inspection_id"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_inspection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/unlink_premise_override(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkPremiseOverrideIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"unlink_premise_override"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/unlink_premise_override(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkPremiseOverrideTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"unlink_premise_override"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/unlink_tech(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkTechIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"unlink_tech"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tce/unlink_tech(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkTechTcePath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tce"],[2,[7,"/"],[2,[6,"unlink_tech"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/unread_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unreadNotificationsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"unread_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/technician_portal/deficiencies/:id/unresolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unresolveApiTechnicianPortalDeficiencyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"technician_portal"],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unresolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/:id/unresolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unresolveDeficiencyPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unresolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contacts/:id/update_account_roles(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAccountRolesContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_account_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspections/:id/update_calendar_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateCalendarDataInspectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_calendar_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:id/update_contact_roles(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateContactRolesBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_contact_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_events/update_event(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateEventApiV1CalendarEventsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_events"],[2,[7,"/"],[2,[6,"update_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series/:id/update_expiring_inspection_series(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateExpiringInspectionSeriesBuildingInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_expiring_inspection_series"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/map/update_fleet_tracking_passengers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateFleetTrackingPassengersMapPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"update_fleet_tracking_passengers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/default_technician_notes/update_notes_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateNotesSettingsDefaultTechnicianNotesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"default_technician_notes"],[2,[7,"/"],[2,[6,"update_notes_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/update_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePasswordUsersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/control_panel_types/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePositionsControlPanelTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"control_panel_types"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/fire_extinguisher_weights/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePositionsFireExtinguisherWeightsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"fire_extinguisher_weights"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/:object_type/generic_question_sections/update_positions(.:format)
 * @param {any} objectType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePositionsGenericQuestionSectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"object_type":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[3,"object_type"],[2,[7,"/"],[2,[6,"generic_question_sections"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/inspection/statuses/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePositionsInspectionStatusesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"inspection"],[2,[7,"/"],[2,[6,"statuses"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_question_sections/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePositionsSystemQuestionSectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_question_sections"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/system_questions/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePositionsSystemQuestionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"system_questions"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/tag_colors/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePositionsTagColorsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tag_colors"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/update_recent_wo_number(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRecentWoNumberWorkOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"update_recent_wo_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/update_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateSettingsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"update_settings"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/buildings/:building_id/inspection_series/:id/update_status(.:format)
 * @param {any} buildingId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStatusBuildingInspectionSeriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"inspection_series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/deficiencies/update_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStatusesDeficienciesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"deficiencies"],[2,[7,"/"],[2,[6,"update_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/update_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStatusesWorkOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"update_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/work_orders/upsert_parent_work_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upsertParentWorkOrderApiV1WorkOrdersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"upsert_parent_work_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/upsert_parent_work_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upsertParentWorkOrderWorkOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"upsert_parent_work_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRegistrationPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSessionPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/permitted_territories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersPermittedTerritoriesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"permitted_territories"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/users/permitted_territories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersPermittedTerritoryPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"permitted_territories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/value-map/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const valueMapAccountPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"value-map"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/value-map/building(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const valueMapBuildingPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"value-map"],[2,[7,"/"],[2,[6,"building"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/proposals/view_and_accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewAndAcceptProposalsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"proposals"],[2,[7,"/"],[2,[6,"view_and_accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/invoices/view_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const viewReportInvoicesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"view_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits/:visit_id/add_material_used(.:format)
 * @param {any} visitId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitAddMaterialUsedPath = /*#__PURE__*/ __jsr.r({"locale":{},"visit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"add_material_used"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits/:visit_id/add_materials_used(.:format)
 * @param {any} visitId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitAddMaterialsUsedPath = /*#__PURE__*/ __jsr.r({"locale":{},"visit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"add_materials_used"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visit_reminders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitRemindersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visit_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits/:visit_id/remove_material_used/:material_id(.:format)
 * @param {any} visitId
 * @param {any} materialId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitRemoveMaterialUsedPath = /*#__PURE__*/ __jsr.r({"locale":{},"visit_id":{"r":true},"material_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"remove_material_used"],[2,[7,"/"],[2,[3,"material_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits/:visit_id/show_modal(.:format)
 * @param {any} visitId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitShowModalPath = /*#__PURE__*/ __jsr.r({"locale":{},"visit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"show_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visit_statuses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visit_statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visit_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitStatusesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visit_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits/:visit_id/update_modal_view(.:format)
 * @param {any} visitId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitUpdateModalViewPath = /*#__PURE__*/ __jsr.r({"locale":{},"visit_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"update_modal_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/irol/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksIrolPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"irol"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/time_entries/week_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weekViewApiV2TimeEntriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"week_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/wo_number_service_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const woNumberServiceSettingsWorkOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"wo_number_service_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/add_contact/:contact_id(.:format)
 * @param {any} workOrderId
 * @param {any} contactId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderAddContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"contact_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"add_contact"],[2,[7,"/"],[2,[3,"contact_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/add_material_needed(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderAddMaterialNeededPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"add_material_needed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/add_material_used(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderAddMaterialUsedPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"add_material_used"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/add_materials_needed(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderAddMaterialsNeededPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"add_materials_needed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/close_and_send_wo(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderCloseAndSendWoPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"close_and_send_wo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_corrections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderCorrectionPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_corrections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_corrections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderCorrectionsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_default_followups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderDefaultFollowupPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_default_followups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_default_followups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderDefaultFollowupsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_default_followups"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/download_pdf(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderDownloadPdfPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/internal_notes_update(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderInternalNotesUpdatePath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"internal_notes_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_line_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderLineItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_line_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_line_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderLineItemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_line_items"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/remove_contact/:contact_id(.:format)
 * @param {any} workOrderId
 * @param {any} contactId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderRemoveContactPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"contact_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"remove_contact"],[2,[7,"/"],[2,[3,"contact_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/remove_inspection_document(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderRemoveInspectionDocumentPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"remove_inspection_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/remove_material_needed/:material_id(.:format)
 * @param {any} workOrderId
 * @param {any} materialId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderRemoveMaterialNeededPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"material_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"remove_material_needed"],[2,[7,"/"],[2,[3,"material_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/remove_material_used/:material_id(.:format)
 * @param {any} workOrderId
 * @param {any} materialId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderRemoveMaterialUsedPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"material_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"remove_material_used"],[2,[7,"/"],[2,[3,"material_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/remove_proposal_document(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderRemoveProposalDocumentPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"remove_proposal_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderReportPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderReportsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_reports"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_statuses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderStatusesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_summary_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderSummaryItemPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_summary_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_summary_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderSummaryItemsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_summary_items"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderTypePath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_order_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderTypesPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_order_types"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/update_status(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderUpdateStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/update_wo_status(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderUpdateWoStatusPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"update_wo_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/work_order_signatures/:id(.:format)
 * @param {any} workOrderId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderWorkOrderSignaturePath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"work_order_signatures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/:work_order_id/work_order_signatures(.:format)
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrderWorkOrderSignaturesPath = /*#__PURE__*/ __jsr.r({"locale":{},"work_order_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"work_order_signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrdersPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/attachments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrdersAttachmentPath = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrdersAttachmentsPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/dashboard/work_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrdersDashboardPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/work_orders/mark_as_published(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workOrdersMarkAsPublishedPath = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"mark_as_published"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/alarm_systems/:alarm_system_id/import/xml(.:format)
 * @param {any} alarmSystemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const xmlAlarmSystemImportPath = /*#__PURE__*/ __jsr.r({"locale":{},"alarm_system_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"alarm_systems"],[2,[7,"/"],[2,[3,"alarm_system_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

